import React, { Component, Fragment } from "react";
import { calculatePrice } from "../../pricing/calculatePrice";
import Axios from "axios";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { configuration } from "../../appConfig";
import PricesZH from "./PricesZH.json";
import Swal from "sweetalert2";
import { updateJsonData } from "../../redux/actions/updateJsonData";
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";
// import "./newswisstabview.css";
import Lightbox from "react-image-lightbox";
import "../dnsReport.css";
import "../dnsReportResponsive.css";
import "react-image-lightbox/style.css"; // This only needs to be imported
import { reportAuthorized } from "../../redux/actions/reportAuthorized";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class NewSwissPriceTable_zh extends Component {
  state = {
    words: {},
    lang: "En",
    swissTableCH: [],
    data: [],
    fullData: [],
    preparation: 10,
    dismantling: "",
    PricePerHour: "",
    SpareParts: 0.0,
    SparePartDetails: "",
    loadedFirstTimeA: true,
    loadedFirstTimeB: true,
    loadedFirstTimeC: true,
    loadedFirstTimeAWc: true,
    loadedFirstTimedisassemblyAssembly: true,
    ALUPercentage: "",
    LAKPercentage: "",
    partsFromAE: "",
    UserEnteredSparePartsDetails: "",
    modal: false,
    modalPartName: "",
    DisassemblyAssemblyPricePerHour: 0,
    disassemblyAssemblyValue: [3, 3, 3, 3, 2, 0, 15, 2, 3, 3, 3, 25, 3, 3],
    originalPreparation: 0,
    loadedFirstTimePreparation: true,
    modal_break: false,
    table_footer_color: "",
    Client: "",
    Platic_part: "",
    imageArr: [],
    imageArrDamage: [],
    currentImageIndex: 0,
    filteredImages: [],
    insuaranceProvider : {}
  };
  count = [];

  componentDidMount() {
    this.getLang();
    this.getData();
    this.getJsonApi();
    this.getScanImages();
  }

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;
        const filterImages = (images, keyword) => {
          return images ? images.filter(image => image.includes(keyword)) : [];
      };

      const Left = [
          ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender")
      ];

      const right = [
          ...filterImages(data.RightFrontFender || data.right, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
          ...filterImages(data.RightBackFender || data.right, "RightBackFender")
      ];

        this.setState({
          imageArr: [
            ...data.Hood,
            ...data.Roof,
            ...data.RightRoofFrame,
            ...data.LeftRoofFrame,
            ...data.TrunkCover,
            ...data.Trunk,
            ...right,
            ...Left,
            
            
          ],
        });
        const LeftDamage = [
          ...filterImages(data.LeftFrontFender_damage , "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor_damage , "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor_damage , "LeftBackDoor"),
          ...filterImages(data.LeftBackFender_damage , "LeftBackFender")
      ];

      const rightDamage = [
          ...filterImages(data.RightFrontFender_damage , "RightFrontFender"),
          ...filterImages(data.RightFrontDoor_damage , "RightFrontDoor"),
          ...filterImages(data.RightBackDoor_damage , "RightBackDoor"),
          ...filterImages(data.RightBackFender_damage , "RightBackFender")
      ];

        this.setState({
          imageArrDamage: [
            ...data.Hood_damage,
            ...data.Roof_damage,
            ...data.RightRoofFrame_damage,
            ...data.LeftRoofFrame_damage,
            ...data.TrunkCover_damage,
            ...data.Trunk_damage,
            ...rightDamage,
            ...LeftDamage,
            
            
          ],
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };

  getJsonApi = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      this.props.reportAuthorized({
        Authorized : r.data.Authorized,
        DATReportAuthorized : r.data.DATReportAuthorized,
        MiniReportAuthorized : r.data.MiniReportAuthorized,
        FullReportAuthorized : r.data.FullReportAuthorized,
        DetailedReportAuthorized : r.data.DetailedReportAuthorized,
        AmericanReportAuthorized : r.data.AmericanReportAuthorized,
      })
      if (r.data) {
        if (r.data.Client != "") {
          this.getInsurenceClients()
        }
        let newStr = [];
        const arrDataAE = [
          //1
          {
            Part: "Hood",
            dataAE: ["Dämmung", "Gitter"],
            shortname: "Hood",
          },
          //2
          {
            Part: "Left Front Fender",
            dataAE: ["Scheinwerfer"],
          },
          //3
          {
            Part: "Left Front Door",
            dataAE: ["Schachtleiste", "Spiegel"],
            shortname: "LFD",
          },
          //4
          {
            Part: "Left Back Door",
            dataAE: ["Schachtleiste", "Spiegel"],
            shortname: "LBD",
          },
          //5
          {
            Part: "Left Back Fender",
            dataAE: [
              "Rücklicht  I",
              "Rücklicht  a",
              "Zierleiste oben",
              "Zierleiste unten",
            ],
            shortname: "LBF",
          },
          //6
          {
            Part: "Trunk",
            dataAE: ["Bremsleucht"],
            shortname: "TR",
          },
          //7
          {
            Part: "Trunk Cover",
            dataAE: ["Bremsleucht"],
            shortname: "TC",
          },
          //8
          {
            Part: "Right Back Fender",
            dataAE: [
              "Rücklicht  I",
              "Rücklicht  a",
              "Zierleiste oben",
              "Zierleiste unten",
            ],
            shortname: "RBF",
          },
          //9
          {
            Part: "Right Back Door",
            dataAE: ["Schachtleiste", "Spiegel"],
            shortname: "RBD",
          },
          //10
          {
            Part: "Right Front Door",
            dataAE: ["Schachtleiste", "Spiegel"],
            shortname: "RFD",
          },
          //11
          {
            Part: "Right Front Fender",
            dataAE: ["Scheinwerfer"],
            shortname: "RFF",
          },
          //12
          {
            Part: "Roof",
            dataAE: ["Himmel", "Dachmatte 2x"],
            shortname: "Roof",
          },
          //13
          {
            Part: "Left Roof Frame",
            dataAE: ["Dachleiste", "Dachreling"],
            shortname: "LRF",
          },
          //14
          {
            Part: "Right Roof Frame",
            dataAE: ["Dachleiste", "Dachreling"],
            shortname: "RRF",
          },
          // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
          // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
          // ["Frontscheibe", "Rahmen", "StoBstange"],
        ];
        if (r.data.Dents) {
          r.data.Dents.map((dent, index) => {
            dent.arrAE = arrDataAE[index];
            if (dent.AE) {
              dent.AE.forEach((value) => {
                newStr.push(`${value}[${dent.arrAE.shortname}]`);
              });
            }
          });
        }

        this.setState(
          {
            fullData: r.data,
            data: r.data.Dents,
            Client: r.data.Client,
            dismantling:
              r.data.Dismantling !== undefined && r.data.Dismantling >= 0
                ? r.data.Dismantling
                : 25,
            preparation:
              r.data.Preparation !== undefined || r.data.Preparation >= 0
                ? r.data.Preparation
                : 10,
            originalPreparation:
              r.data.Preparation !== undefined || r.data.Preparation >= 0
                ? r.data.Preparation
                : 10,
                PricePerHour: (r.data.PricePerHour !== undefined && r.data.PricePerHour && r.data.TabViewPriceUpdated) ? (r.data.PricePerHour).toFixed(2) : 0, 
          DisassemblyAssemblyPricePerHour: (r.data.DisassemblyAssemblyPricePerHour !== undefined && r.data.DisassemblyAssemblyPricePerHour && r.data.TabViewPriceUpdated) ? (r.data.DisassemblyAssemblyPricePerHour).toFixed(2) : 0,
            // PricePerHour:
            //   (r.data.PricePerHour !== undefined &&
            //     r.data.PricePerHour &&
            //     r.data.PricePerHour.toFixed(2)) ||
            //   "",
            // DisassemblyAssemblyPricePerHour:
            //   r.data.DisassemblyAssemblyPricePerHour !== undefined &&
            //   r.data.DisassemblyAssemblyPricePerHour
            //     ? r.data.DisassemblyAssemblyPricePerHour.toFixed(2)
            //     : 0,
            SpareParts:
            (r.data.SpareParts && parseInt(r.data.SpareParts).toFixed(2)) || 0,
            SparePartDetails: r.data.SparePartDetails || "",
            partsFromAE: newStr.toString(),
            UserEnteredSparePartsDetails:
              r.data.UserEnteredSparePartsDetails || "",
          },
          () => {
            this.getFallbackDetails(r.data.PricePerHour,r.data.DisassemblyAssemblyPricePerHour);
          }
        );
        this.setState({ data: r.data.Dents }, () => {
          this.updateReduxJson();
          if (this.state.data) {
            this.state.data.map((dent, index) =>
              this.getAWaAWbFirstTime(dent, index)
            );
          }
        });
      }
    });
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");

    if (partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
    const response = await Axios.post(url)
    if (response.data) {
      response.data.map((info)=>{
        if (this.state.Client && this.state.Client != undefined && this.state.Client != "" && this.state.Client.toLocaleLowerCase() &&this.state.Client.toLocaleLowerCase() == info.Name.toLocaleLowerCase()) {
          this.setState({insuaranceProvider : info})
        }
      })
      }
    }
  };

  getData = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    const res = await Axios.get(
      configuration.getResultCH + "?vin=" + vin + "&partnerId=" + partnerId
    );
    if (res.data && res.data.json) {
      let { json } = res.data;
      //debugger;
      const data = json.split("\n").splice(3);
      data.pop();
      // conver data into following format
      // 1. part lt25 gt25 aw<25 aw>25

      const ltgtdataCH =
        data &&
        data.map((row) => {
          const val = row.split(/\s+/);
          let ltcount = val[2];
          let gtcount = val[3];
          return {
            part: val[1],
            count: parseInt(val[2]) + parseInt(val[3]),
            lt25: val[2],
            gt25: val[3],
            ltunit: calculatePrice(24, ltcount | 0),
            gtunit: calculatePrice(26, gtcount | 0),
            total: parseInt(val[2]) + parseInt(val[3]),
          };
        });
      this.setState({ swissTableCH: ltgtdataCH });
    }
    // debugger;
  };

  getAWaAWbFirstTime = (row, index) => {
    const { data } = this.state;
    let sizeA, sizeB;
    if (row.Part === "TrunkCover") {
      sizeA = row["A"];
      // data[findWithAttr(data, 'Part', 'Trunk')]['B'] = 0
      sizeA = row["A"] + data[findWithAttr(data, "Part", "Trunk")]["A"];
      sizeB =
        (row["B"] ? row["B"] : 0) +
        (row["C"] ? row["C"] : 0) +
        (data[findWithAttr(data, "Part", "Trunk")]["B"]
          ? data[findWithAttr(data, "Part", "Trunk")]["B"]
          : 0) +
        (data[findWithAttr(data, "Part", "Trunk")]["C"]
          ? data[findWithAttr(data, "Part", "Trunk")]["C"]
          : 0);
    } else {
      sizeA = row["A"];
      sizeB = row["B"];
    }
    if (row.Part !== "TrunkCover" && row["C"] !== undefined) {
      sizeB = sizeB + row["C"];
    }
    let UpdatedAwa = [];
    PricesZH.forEach((price) => {
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    });
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesZH.reduce((prev, curr) => {
        return Math.abs(curr.val - parseInt(sizeA)) <
          Math.abs(prev.val - parseInt(sizeA))
          ? curr
          : prev;
      });
    }
    if (row.Part === "TrunkCover") {
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
      data[findWithAttr(data, "Part", "Trunk")]["AWa"] = 0;
    } else {
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
    }

    //getting AWb
    let UpdatedAwb = [];
    PricesZH.forEach((price) => {
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    });
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesZH.reduce((prev, curr) => {
        return Math.abs(curr.val - parseInt(sizeB)) <
          Math.abs(prev.val - parseInt(sizeB))
          ? curr
          : prev;
      });
    }

    if (row.Part === "TrunkCover") {
      data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
      data[findWithAttr(data, "Part", "Trunk")]["AWb"] = 0;
    } else {
      data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
    }
    data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh

    this.updateReduxJson();
    this.setState(
      {
        data,
      },
      () => {}
    );
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    let currentLang;
    if (lang === "fr") {
      currentLang = "ch-fr";
    } else {
      currentLang = lang;
    }
    return words[word] ? words[word][currentLang] : word;
  };

  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.jsonData) {
      this.setState({
        fullData: nextProps.jsonData,
      });
    }
    if (nextProps.lang !== prevState.lang) {
      this.setState({ lang: nextProps.lang });
    } else if (nextProps.Authorized !== prevState.Authorized) {
      prevState.fullData.Authorized = nextProps.Authorized;
      this.setState({
        Authorized: nextProps.Authorized,
      });
    } else return null;
  }

  mergeTrunkAndTrunkCover = () => {
    const { fullData } = this.state;
    fullData &&
      fullData.Dents &&
      fullData.Dents.length &&
      fullData.Dents.map((row, i) => {
        if (row.Part === "TrunkCover") {
          fullData.Dents[i]["A"] =
            fullData.Dents[i]["A"] +
            fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")]["A"];
          fullData.Dents[i]["B"] =
            fullData.Dents[i]["B"] +
            fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")]["B"];
          fullData.Dents[i]["C"] =
            fullData.Dents[i]["C"] +
            fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")]["C"];
          fullData.Dents[i]["TotalDents"] =
            fullData.Dents[i]["A"] +
            fullData.Dents[i]["B"] +
            (fullData.Dents[i]["C"] || 0);
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "A"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "B"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "C"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "TotalDents"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "AvgDiaMm"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "AvgDiaPx"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "AWa"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "AWb"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "AWc"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "AW"
          ] = 0;
          fullData.Dents[findWithAttr(fullData.Dents, "Part", "Trunk")][
            "Price"
          ] = 0;
        } else if (row.Plastic) {
          fullData.Dents[i]["TotalDents"] = 0;
        }
      });
    this.setState(
      {
        fullData: {...this.state.fullData, IsPriceTableUpdated : true, PartnerID: localStorage.getItem(
          "partnerId"
        )},
      },
      () => {
        this.props.getUpdatedStateFromPriceTable(false);
        this.props.updateJsonData(this.state.fullData);
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        const url =
          configuration.PostEditorChanges +
          `?partnerId=${localStorage.getItem(
            "partnerId"
          )}&vin=${localStorage.getItem(
            "selectedFile"
          )}&TabViewUpdated=${!fullData.TabViewUpdated}`;

        Axios.post(url, this.state.fullData)
          .then((res) => {
            Toast.fire({
              type: "success",
              title: "Data saved successfully",
            });
            this.getScanImages();
            this.props.getUpdatedStateFromPriceTable(true);
            this.setState({
              modal_break: false,
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((err) => {
            this.setState({
              modal_break: false,
            });
            Toast.fire({
              type: "error",
              title: "Something went wrong",
            });
          });
      }
    );
  };

  saveChanges = async () => {
    await this.mergeTrunkAndTrunkCover();
  };

  change = (part, e, index, key) => {
    const { name } = e.target;
    const { data, fullData } = this.state;

    //   if (key === "Plastic") {
    //     if (!data[index][key]) {
    //       // data[index]["Alu"] = false;
    //       // data[index]["Push2paint"] = false;
    //     }else{
    //       data[index][key] = e.target.checked
    //     }
    // }
    data[index][key] = e.target.checked;

    if (data[index]["TotalDents"] > 607 || data[index]["B"] > 199) {
      return;
    } else {
      if (e.target.checked) {
        if (name === "check_E") {
          //uncheck Check_I_LI
          data[index]["Replace"] = "check_E";
        } else {
          //uncheck Check_E
          data[index]["Replace"] = "Check_I_LI";
        }
      } else {
        data[index]["Replace"] = "";
      }
      this.setState({ fullData }, () => {
        // this.props.getUpdatedStateFromPriceTable(this.state.fullData)
        // this.saveChanges();
      });
    }
    if (key == "Plastic") {
      // this.handleSave();
    }
  };

  getTotalAw = () => {
    const { data, loadedFirstTimePreparation, originalPreparation } =
      this.state;
    const total =
      data &&
      data.reduce((acc, num) => {
        if (
          num.Part !== "Trunk" &&
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          return (
            parseFloat(acc) +
            parseFloat(
              num.Plastic
                ? 0
                : num.Replacing
                ? 0 || num.Replacingvalue
                : num.Preprints
                ? num.Replacingvalue
                : this.getAluLakAddedAW(num)
            )
          );
        } else {
          return parseFloat(acc).toFixed(2);
        }
      }, 0);
    if (Number(total) === 0) {
      this.setState((prev) => {
        if (prev.preparation !== 0) {
          return { preparation: 0, loadedFirstTimePreparation: true };
        }
      });
    } else if (loadedFirstTimePreparation) {
      this.setState((prev) => {
        if (prev.preparation !== originalPreparation) {
          return {
            preparation: originalPreparation,
            loadedFirstTimePreparation: false,
          };
        }
      });
    }
    return Number(total);
  };

  getAddedTotalAW = () => {
    const { preparation } = this.state;
    const total = parseInt(preparation) + this.getTotalAw();
    return total.toFixed(2);
  };

  getRepairCost = () => {
    var repairCost =
      (this.getAddedTotalAW() / 10) * parseFloat(this.state.PricePerHour) +
      (this.getAddedTotalDisassemblyAssemblyAW() / 10) *
        parseFloat(this.state.DisassemblyAssemblyPricePerHour) +
      parseFloat(this.state.SpareParts) +
      parseFloat(this.getKleinMaterial());
    repairCost = this.roundOfFiveAfterDecimal(repairCost);
    repairCost = Intl.NumberFormat("it-CH", {
      currency: "CHF",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(repairCost.toFixed(2));
    return repairCost;
  };

  roundOfFiveAfterDecimal = (repairCost) => {
    let numberBeforeDecimal = 0,
      numberAfterDecimal = 0;
    numberAfterDecimal = parseInt((repairCost % 1).toFixed(2).substring(2));
    numberBeforeDecimal = parseInt(repairCost);
    let finalRepairCost = 0;
    if (numberAfterDecimal > 97) {
      finalRepairCost = parseFloat(numberBeforeDecimal + 1);
    } else if (numberAfterDecimal < 8) {
      finalRepairCost = parseFloat(numberBeforeDecimal);
    } else {
      let decimal =
        numberAfterDecimal % 5 >= 2.5
          ? parseInt(numberAfterDecimal / 5) * 5 + 5
          : parseInt(numberAfterDecimal / 5) * 5;
      finalRepairCost = parseFloat(numberBeforeDecimal + "." + decimal);
    }
    return parseFloat(finalRepairCost);
  };

  handleChange = (e, action) => {
    const { name, value } = e.target;

    let newValue;
    if (action === "increment") {
      newValue = parseFloat(this.state[name]) + 1;
    } else if (action === "decrement") {
      newValue =
        parseFloat(this.state[name]) > 0 ? parseFloat(this.state[name]) - 1 : 0;
    } else {
      newValue = value === "" ? 0 : parseFloat(value);
    }

    this.setState(
      {
        [name]: newValue,
      },
      () => {
        this.updateReduxJson();
      }
    );
  };

  updateReduxJson = () => {
    const { fullData, data } = this.state;
    if (
      fullData.hasOwnProperty("Kleinmaterial") ||
      fullData.hasOwnProperty("grandTotalExMwSt")
    ) {
      delete fullData["Kleinmaterial"];
      delete fullData["grandTotalExMwSt"];
    }
    // var repairCost = (this.getAddedTotalAW() / 10 ) * parseFloat(this.state.PricePerHour) + parseFloat(this.state.SpareParts) + parseFloat(this.getKleinMaterial());
    fullData.Dismantling = parseFloat(
      parseFloat(this.state.dismantling).toFixed(2)
    );
    fullData.Preparation = parseFloat(
      parseFloat(this.state.preparation).toFixed(2)
    );
    fullData.PricePerHour = parseFloat(
      parseFloat(this.state.PricePerHour).toFixed(2)
    );
    fullData.DisassemblyAssemblyPricePerHour = parseFloat(
      parseFloat(this.state.DisassemblyAssemblyPricePerHour).toFixed(2)
    );
    fullData.SpareParts = parseFloat(
      parseFloat(this.state.SpareParts).toFixed(2)
    );
    fullData.SmallMaterial = parseFloat(this.getKleinMaterial());
    // fullData.TotalPrice = parseFloat(this.getAmount());
    fullData.TotalPrice = parseFloat(
      this.roundOfFiveAfterDecimal(
        isNaN(this.getAddedTotalAW())
          ? 0
          : this.getAddedTotalAW() * this.state.PricePerHour * 0.1
      ).toFixed(2)
    );
    fullData.DisassemblyAssemblyAmount = parseFloat(
      this.roundOfFiveAfterDecimal(
        (isNaN(this.getAddedTotalDisassemblyAssemblyAW())
          ? 0
          : this.getAddedTotalDisassemblyAssemblyAW() *
            this.state.DisassemblyAssemblyPricePerHour *
            0.1
        ).toFixed(2)
      )
    );
    // fullData.GrandTotalExVAT = parseFloat(this.getRepairCost())
    fullData.GrandTotalExVAT = parseFloat(
      this.roundOfFiveAfterDecimal(
        (((this.getAddedTotalAW() / 10) * parseFloat(this.state.PricePerHour) +
          (this.getAddedTotalDisassemblyAssemblyAW() / 10) *
            parseFloat(this.state.DisassemblyAssemblyPricePerHour) +
          parseFloat(this.state.SpareParts) +
          parseFloat(this.getKleinMaterial())) *
          2) /
          2
      ).toFixed(2)
    );
    if (this.state.partsFromAE.length > 0) {
      if (this.state.UserEnteredSparePartsDetails.length > 0) {
        fullData.SparePartDetails =
          this.state.UserEnteredSparePartsDetails +
          "," +
          " " +
          this.state.partsFromAE;
      } else {
        fullData.SparePartDetails = this.state.partsFromAE
          .split(",")
          .join(", ");
      }
    } else {
      fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails;
    }
    fullData.UserEnteredSparePartsDetails =
      this.state.UserEnteredSparePartsDetails;
    //for updating the AW in json
    if (data) {
      data.forEach((row) => {
        row.AW = this.getAluLakAddedAW(row);
        if (row.Plastic) {
          row.A = 0;
          row.B = 0;
          row.C = 0;
          row.AWc = 0;
          row.AW = 0.0;
          row.Alu = false;
          row.Push2paint = false;
          row.Replacingvalue = 0.0;
        }
        if (row.Replacing) {
          // row.Replacingvalue = 0.00
          row.AW = row.Replacingvalue;
        }
        if (row.Preprints) {
          row.AW = row.Replacingvalue;
        }
      });
    }
    this.setState({ data, fullData });
    this.props.updateJsonData(this.state.fullData);
  };

  getTotalDents = () => {
    const { Dents } = this.state.fullData;
    let totalDents =
      Dents &&
      Dents.reduce((acc, num) => {
        if (
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          return (
            parseInt(acc) +
            (num.Plastic == true ? 0 : parseInt(num.A) ? parseInt(num.A) : 0) +
            (num.Plastic == true ? 0 : parseInt(num.B) ? parseInt(num.B) : 0) +
            (num.Plastic == true ? 0 : parseInt(num.C) ? parseInt(num.C) : 0)
          );
        } else {
          return parseInt(acc);
        }
      }, 0);
    return totalDents;
  };

  handleSave = () => {
    const { fullData, data } = this.state;
    if (!!fullData) {
      this.setState({
        modal_break: true,
      });
      if (
        fullData.hasOwnProperty("Kleinmaterial") ||
        fullData.hasOwnProperty("grandTotalExMwSt")
      ) {
        delete fullData["Kleinmaterial"];
        delete fullData["grandTotalExMwSt"];
      }
      // var repairCost = (this.getAddedTotalAW() / 10 ) * parseFloat(this.state.PricePerHour) + parseFloat(this.state.SpareParts) + this.getKleinMaterial();
      fullData.Dismantling = parseFloat(
        parseFloat(this.state.dismantling).toFixed(2)
      );
      fullData.Preparation = parseFloat(
        parseFloat(this.state.preparation).toFixed(2)
      );
      fullData.PricePerHour = parseFloat(
        parseFloat(this.state.PricePerHour).toFixed(2)
      );
      fullData.SpareParts = parseFloat(
        parseFloat(this.state.SpareParts).toFixed(2)
      );
      fullData.SmallMaterial = parseFloat(this.getKleinMaterial());
      // fullData.TotalPrice = parseFloat(this.getAmount());
      fullData.TotalPrice = parseFloat(
        this.roundOfFiveAfterDecimal(
          isNaN(this.getAddedTotalAW())
            ? 0
            : this.getAddedTotalAW() * this.state.PricePerHour * 0.1
        ).toFixed(2)
      );
      // fullData.GrandTotalExVAT = parseFloat(this.getRepairCost())
      fullData.GrandTotalExVAT = parseFloat(
        this.roundOfFiveAfterDecimal(
          (((this.getAddedTotalAW() / 10) *
            parseFloat(this.state.PricePerHour) +
            (this.getAddedTotalDisassemblyAssemblyAW() / 10) *
              parseFloat(this.state.DisassemblyAssemblyPricePerHour) +
            parseFloat(this.state.SpareParts) +
            parseFloat(this.getKleinMaterial())) *
            2) /
            2
        ).toFixed(2)
      );
      fullData.DisassemblyAssemblyPricePerHour = parseFloat(
        parseFloat(this.state.DisassemblyAssemblyPricePerHour).toFixed(2)
      );
      fullData.DisassemblyAssemblyAmount = parseFloat(
        this.roundOfFiveAfterDecimal(
          (isNaN(this.getAddedTotalDisassemblyAssemblyAW())
            ? 0
            : this.getAddedTotalDisassemblyAssemblyAW() *
              this.state.DisassemblyAssemblyPricePerHour *
              0.1
          ).toFixed(2)
        )
      );
      fullData.TotalDentCount = this.getTotalDents();
      if (this.state.partsFromAE.length > 0) {
        if (this.state.UserEnteredSparePartsDetails.length > 0) {
          fullData.SparePartDetails =
            this.state.UserEnteredSparePartsDetails +
            "," +
            " " +
            this.state.partsFromAE;
        } else {
          fullData.SparePartDetails = this.state.partsFromAE
            .split(",")
            .join(", ");
        }
      } else {
        fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails;
      }

      fullData.UserEnteredSparePartsDetails =
        this.state.UserEnteredSparePartsDetails;
      //for updating the AW in json
      data.forEach((row) => {
        row.AW = this.getAluLakAddedAW(row);
        if (row.Plastic) {
          row.A = 0;
          row.B = 0;
          row.C = 0;
          row.AWc = 0;
          row.AW = 0.0;
          row.Alu = false;
          row.Push2paint = false;
          row.Replacingvalue = 0.0;
          // row.Replacing = false;
          // row.Preprints = false;
        }
        if (row.Replacing) {
          // row.Replacingvalue = 0.00
          row.AW = row.Replacingvalue;
        }
        if (row.Preprints) {
          row.AW = row.Replacingvalue;
        }
      });
      this.setState({ data, fullData }, () => {
        this.saveChanges();
      });
    }
  };

  getAWaAWb = (AWa, AWb) => {
    if (AWa === undefined) {
      AWa = 0;
    }

    if (AWb === undefined) {
      AWb = 0;
    }
    let final = {
      AWa,
      AWb,
    };
    // if(AWa < AWb && AWa > 0){
    //   final.AWa = (Math.round(AWa * 0.7));
    // } else if(AWa > AWb && AWb > 0){
    //   final.AWb = (Math.round(AWb * 0.7));
    // } else if (AWa === AWb && AWa > 0 && AWb > 0) {
    //   final.AWa = (Math.round(AWa * 0.7));
    // }
    return final;
  };

  hadnleDentsChanges = (part, e, index, key) => {
    const { data } = this.state;
    const { name, value } = e.target;
    if (key === "loadedFirstTimeA") {
      this.setState({
        loadedFirstTimeA: false,
      });
    } else if (key === "loadedFirstTimeB") {
      this.setState({
        loadedFirstTimeB: false,
      });
    } else if (key === "loadedFirstTimeC") {
      this.setState({
        loadedFirstTimeC: false,
      });
    }

    data[index][name] = Math.abs(value ? parseInt(value) : 0);
    data[index]["TotalDents"] =
      data[index]["A"] +
      data[index]["B"] +
      (data[index]["C"] ? data[index]["C"] : 0);
    let deviation;
    if (part === "TrunkCover") {
      deviation =
        data[index]["TotalDents"] +
        data[findWithAttr(data, "Part", "Trunk")]["TotalDents"] -
        (data[index]["OriginalDents"] +
          data[findWithAttr(data, "Part", "Trunk")]["OriginalDents"]);
    } else {
      deviation = data[index]["TotalDents"] - data[index]["OriginalDents"];
    }

    if (deviation > 0) {
      data[index]["AddedCount"] = deviation;
      data[index]["RemovedCount"] = 0;
    } else {
      data[index]["RemovedCount"] = Math.abs(deviation);
      data[index]["AddedCount"] = 0;
    }

    // Replace check
    if (data[index]["TotalDents"] > 607 || data[index]["B"] > 199) {
      data[index]["Replace"] = "Check_I_LI";
    } else {
      data[index]["Replace"] = "";
    }

    /* let UpdatedAwa = [];
    
    PricesZH.forEach((price)=>{
      if (price.val === parseInt(value)) {
        UpdatedAwa.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesZH.reduce((prev, curr)=>{
        return (Math.abs(curr.val - value)) < (Math.abs(prev.val - value)) ? curr : prev
      })
    }

    if (name === 'A') {
      data[index]["AWa"] = UpdatedAwa[0].AWa
    } else if (name === 'B'){
      data[index]["AWb"] = UpdatedAwa[0].AWb
    } */

    //getting AWa
    let sizeA, sizeB;
    if (part === "TrunkCover") {
      if (name === "A") {
        data[findWithAttr(data, "Part", "Trunk")]["A"] = 0;
        sizeB =
          data[index]["B"] + data[findWithAttr(data, "Part", "Trunk")]["B"];
        sizeA = data[index]["A"];
      } else if (name === "B" || name === "C") {
        data[findWithAttr(data, "Part", "Trunk")]["B"] = 0;
        data[index]["C"] =
          data[index]["C"] + data[findWithAttr(data, "Part", "Trunk")]["C"];
        data[findWithAttr(data, "Part", "Trunk")]["C"] = 0;
        sizeA =
          data[index]["A"] + data[findWithAttr(data, "Part", "Trunk")]["A"];
        sizeB = data[index]["B"];
      }
    } else {
      sizeA = data[index]["A"];
      sizeB = data[index]["B"];
    }
    if (data[index]["C"] !== undefined) {
      sizeB = sizeB + data[index]["C"];
    }
    let UpdatedAwa = [];
    PricesZH.forEach((price) => {
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    });
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesZH.reduce((prev, curr) => {
        return Math.abs(curr.val - parseInt(sizeA)) <
          Math.abs(prev.val - parseInt(sizeA))
          ? curr
          : prev;
      });
    }
    if (part === "TrunkCover") {
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
      data[findWithAttr(data, "Part", "Trunk")]["AWa"] = 0;
    } else {
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
    }

    //getting AWb
    let UpdatedAwb = [];
    PricesZH.forEach((price) => {
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    });
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesZH.reduce((prev, curr) => {
        return Math.abs(curr.val - parseInt(sizeB)) <
          Math.abs(prev.val - parseInt(sizeB))
          ? curr
          : prev;
      });
    }

    if (part === "TrunkCover") {
      data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
      data[findWithAttr(data, "Part", "Trunk")]["AWb"] = 0;
    } else {
      data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
    }
    data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh

    this.updateReduxJson();
    this.setState(
      {
        data,
      },
      () => {}
    );
  };
  // For AWcChanges
  handleAWchanges = (index, e) => {
    this.setState({
      loadedFirstTime: false,
      loadedFirstTimeAWc: false,
      loadedFirstTimedisassemblyAssembly: false,
    });
    const { data } = this.state;
    const { name, value } = e.target;
    data[index][name] = value ? parseInt(value) : 0;
    this.setState({
      data,
    });
    this.updateReduxJson();
  };

  getFallbackDetails = async (pricePerHour, DisassemblyAssemblyPricePerHour) => {
    try {
      const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await Axios.get(url);

      if (res.data) {
        function hexToRgb(hex) {
          hex = hex.replace(
            /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
            (m, r, g, b) => "#" + r + r + g + g + b + b
          );
          let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result
            ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16),
              }
            : null;
        }

        let rgbColor = hexToRgb(this.state.insuaranceProvider.PrimaryColor || res.data.primary_color);
        let rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;

        this.props.getSelectedPartnerId({
          duplicateSelectedPartnerId : res.data.vin_duplicate_partner_id.length > 0 ? res.data.vin_duplicate_partner_id : [],
          isDuplicateVin : res.data.is_vin_duplicate
        })
        this.setState({
          ALUPercentage: res.data.alu,
          LAKPercentage: res.data.lak,
          table_footer_color: res.data.table_footer_color,
          PrimaryColor: res.data.primary_color || "#FF0000",
          SecondaryColor: res.data.secondary_color || "#000000",
          PrimaryTextColor: res.data.primary_text_color || "#000000",
          SecondaryTextColor: res.data.secondary_text_color || "#fff",
          rgbaColor: rgbaColor,
        });
        if (!this.state.PricePerHour) {
          this.setState({
            PricePerHour:res.data.PricePerHour && res.data.PricePerHour !== "0.00" && res.data.PricePerHour !== 0.00 && res.data.PricePerHour != 0 ? res.data.PricePerHour : pricePerHour,
          })
        }
        if (!this.state.DisassemblyAssemblyPricePerHour) {
          this.setState({
            DisassemblyAssemblyPricePerHour: res.data.basePrice && res.data.basePrice !== "0.00" && res.data.basePrice !==0.00 && res.data.basePrice != 0 ? res.data.basePrice : DisassemblyAssemblyPricePerHour,
          })
        }
        this.updateReduxJson();
      }
    } catch (error) {
      this.setState({
        ALUPercentage: "",
        LAKPercentage: "",
      });
    }
  };

  handleAluLakChanges = (e, index, key) => {
    const { data } = this.state;
    data[index][key] = e.target.checked;
    // for updating AW in json
    data[index]["AW"] = this.getAluLakAddedAW(data[index]);
    this.setState({ data }, async () => {
      // this.props.getUpdatedStateFromPriceTable(this.state.fullData);
      await this.updateReduxJson();
      // await this.saveChanges();
    });
  };

  handleReplaceChanges = (e, index, key) => {
    const { data, Client } = this.state;
    data[index][key] = e.target.checked;
    if (data[index]["Preprints"]) {
      if (Client.toLowerCase().includes("amag")) {
        data[index]["Replacingvalue"] = (data[index]["AW"] * 0.6).toFixed(2);
      } else {
        data[index]["Replacingvalue"] = (data[index]["AW"] * 0.5).toFixed(2);
      }
    } else {
      data[index]["Replacingvalue"] = "0.00";
    }
    this.setState({ data }, async () => {
      await this.updateReduxJson();
    });
  };

  handleInputChange = (e, part, index) => {
    const { data } = this.state;
    data[index]["Replacingvalue"] = parseFloat(e.target.value);
    this.setState({ data });
  };

  // main function recalculate the AW after evey change
  updateFinalAW = (row, index) => {
    //first apply the 70% formula and get total AW (updated values based on priceCH)
    let aw70 =
      this.getAWaAWb(row.AWa, row.AWb).AWa +
      this.getAWaAWb(row.AWa, row.AWb).AWb;

    //check if alu/lak is enabled or not
    const { ALUPercentage, LAKPercentage } = this.state;
    let aluPr = parseFloat(ALUPercentage);
    let lakPr = parseFloat(LAKPercentage);

    let incPR = 0;
    if (row.Alu && row.Push2paint) {
      //if Alu and lak both are enabled
      incPR = aluPr + lakPr;
    } else if (row.Alu) {
      //if only Alu is enabled
      incPR = aluPr;
    } else if (row.Push2paint) {
      //if only Push2paint is enabled
      incPR = lakPr;
    } else {
      //if only Push2paint is enabled
      incPR = 0;
    }
    if (incPR !== 0) {
      aw70 =
        0 || Math.ceil(parseFloat(aw70) + (parseFloat(aw70) * incPR) / 100.0);
    }
    // if (this.state.finalAW[index]) {
    this.state.finalAW[index].AW = aw70;
    this.setState({
      finalAW: this.state.finalAW,
    });
    // }
  };

  // function To generate originalAW (without alu/lak) runtime

  // --------------Algo ------------------------
  // 1. take size A and B from json
  // 2. aquire AWa and AWb from priceCH based on size A and B
  // 3. Apply 70% formula
  // 4. Add final AWa and AWb values to form original AW

  getOriginalAW = (
    sizeA,
    sizeB,
    jsonAWa,
    jsonAWb,
    sizeC,
    jsonAWc,
    part,
    isNotCapping
  ) => {
    // 1.) getting AWa and AWb values based on sizeA and sizeB from PriceCH
    // ------------------------------------------------------------------------
    let AWa, AWb;
    /* let AWa = jsonAWa;
    let AWb = jsonAWb; */

    //getting AWa
    let UpdatedAwa = [];
    PricesZH.forEach((price) => {
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    });
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesZH.reduce((prev, curr) => {
        return Math.abs(curr.val - parseInt(sizeA)) <
          Math.abs(prev.val - parseInt(sizeA))
          ? curr
          : prev;
      });
    }
    AWa = UpdatedAwa[0].AWa; //AWa based on PriceCh
    if (sizeC !== undefined) {
      sizeB = sizeB + sizeC;
    }
    //getting AWb
    let UpdatedAwb = [];
    PricesZH.forEach((price) => {
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    });
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesZH.reduce((prev, curr) => {
        return Math.abs(curr.val - parseInt(sizeB)) <
          Math.abs(prev.val - parseInt(sizeB))
          ? curr
          : prev;
      });
    }
    AWb = UpdatedAwb[0].AWb; //AWb based on PriceCh

    // 2.) Applying 70% formula on updated AWa, AWb
    // ------------------------------------------------------------------------
    // let AWa70 = this.getAWaAWb(AWa, AWa).AWa;
    // let AWb70 = this.getAWaAWb(AWa, AWa).AWb;

    if (part === "TrunkCover") {
      const { data } = this.state;
      AWa = AWa + data[findWithAttr(data, "Part", "Trunk")].AWa;
      AWb = AWb + data[findWithAttr(data, "Part", "Trunk")].AWb;
      data[findWithAttr(data, "Part", "Trunk")].AWa = 0;
      data[findWithAttr(data, "Part", "Trunk")].AWb = 0;
      // if(AWa < AWb && AWa > 0){
      //   AWa = (AWa * 0.7);
      // } else if(AWa > AWb && AWb > 0){
      //   AWb = (AWb * 0.7);
      // } else if (AWa === AWb && AWa > 0 && AWb > 0) {
      //   AWa = (AWa * 0.7);
      // }
    }
    let totalAWaAWb = AWa + AWb;
    // if (totalAWaAWb > 111) {
    //   totalAWaAWb = 111
    // }

    if (isNotCapping) {
      totalAWaAWb = AWa + AWb;
    }
    // AWc Add in total Aw
    let AWc = jsonAWc ? jsonAWc : 0;
    // 3.) Add final AWa and AWb values to form original AW
    // ------------------------------------------------------------------------
    let originalAW = totalAWaAWb + AWc;
    // let originalAW = AWa + AWb + AWc;
    originalAW = originalAW.toFixed(2);
    return parseFloat(originalAW);
  };

  //function to get Alu and lak based AW
  getAluLakAddedAW = (row) => {
    const { data } = this.state;
    let originalAW = this.getOriginalAW(
      row.A,
      row.B,
      row.AWa,
      row.AWb,
      row.C,
      row.AWc,
      row.Part
    );
    if (row.Part === "TrunkCover") {
      originalAW = this.getOriginalAW(
        row.A + data[findWithAttr(data, "Part", "Trunk")]["A"],
        row.B + data[findWithAttr(data, "Part", "Trunk")]["B"],
        row.AWa,
        row.AWb,
        (row.C ? row.C : 0) +
          (data[findWithAttr(data, "Part", "Trunk")]["C"]
            ? data[findWithAttr(data, "Part", "Trunk")]["C"]
            : 0),
        row.AWc
      );
    }
    let finalAW;
    let finalAWC = 0;

    //check if alu/lak is enabled or not
    const { ALUPercentage, LAKPercentage } = this.state;
    let aluPr = parseFloat(ALUPercentage);
    let lakPr = parseFloat(LAKPercentage);

    let incPR = 0;
    // if (row.Alu && row.Push2paint) {
    //   //if Alu and lak both are enabled
    //   incPR = aluPr + lakPr;
    // } else if (row.Alu) {
    //   //if only Alu is enabled
    //   incPR = aluPr;
    // } else if (row.Push2paint) {
    //   //if only Push2paint is enabled
    //   incPR = lakPr;
    // } else {
    //   //if only Push2paint is enabled
    //   incPR = 0;
    // }

    if (row.Alu && row.Push2paint && row.GrFlache) {
      //if Alu and lak both are enabled
      incPR = aluPr + lakPr + 25;
    } else if (row.Alu && row.Push2paint) {
      incPR = aluPr + lakPr;
    } else if (row.Push2paint && row.GrFlache) {
      incPR = 25 + lakPr;
    } else if (row.GrFlache && row.Alu) {
      incPR = 25 + aluPr;
    } else if (row.Alu) {
      //if only Alu is enabled
      incPR = aluPr;
    } else if (row.Push2paint) {
      //if only Push2paint is enabled
      incPR = lakPr;
    } else if (row.GrFlache) {
      incPR = 25;
    } else {
      //if only Push2paint is enabled
      incPR = 0;
    }
    // if(row.GrFlache && row.AWc >= 0){
    //   finalAWC = (parseFloat(row.AWc)) + ((parseFloat(row.AWc) * 25) / 100.0)
    // } else if (row.AWc >= 0){
    //   finalAWC = (parseFloat(row.AWc))
    // }

    if (incPR !== 0) {
      // finalAW = 0 || Math.ceil(
      //   parseFloat(originalAW) +
      //   (parseFloat(originalAW) * incPR) /
      //   100.0
      //   );
      finalAW =
        0 || parseFloat(originalAW) + (parseFloat(originalAW) * incPR) / 100.0;
    } else {
      finalAW = originalAW;
    }

    finalAW = this.round(finalAW);
    // finalAW = finalAW + finalAWC ;
    return finalAW.toFixed(2);
  };

  getReplaceingAddedAW = () => {
    const { data } = this.state;
    const total =
      data &&
      data.reduce((acc, num) => {
        if (
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          // return parseFloat(acc) + parseFloat(num.Replacingvalue ? num.Replacingvalue : 0);
          return (
            parseFloat(acc) +
            parseFloat(
              num.Plastic
                ? 0
                : num.Replacingvalue && num.Replacingvalue
                ? num.Replacingvalue
                : 0
            )
          );
        } else {
          return parseFloat(acc);
        }
      }, 0);
    return parseFloat(total);
  };

  round = (digit) => {
    let numberAfterDecimal = 0,
      result = 0;
    numberAfterDecimal = digit.toString().split(".")[1];
    if (numberAfterDecimal && numberAfterDecimal[2] > 4) {
      if (numberAfterDecimal[0] == 0) {
        numberAfterDecimal = parseInt(numberAfterDecimal.slice(0, -1)) + 1;
        result = parseFloat(parseInt(digit) + ".0" + numberAfterDecimal);
      } else {
        numberAfterDecimal = parseInt(numberAfterDecimal.slice(0, -1)) + 1;
        result = parseFloat(parseInt(digit) + "." + numberAfterDecimal);
      }
    } else {
      result = digit;
    }
    return result;
  };

  changeAE = (event, index, value, key) => {
    const { data, fullData } = this.state;
    const aeArr = Array.isArray(data[index]["AE"]) ? data[index]["AE"] : [];
    if (event.target.checked) {
      aeArr.push(`${value}`);
    } else {
      aeArr.map((val, idx) => {
        if (value == val) {
          aeArr.splice(idx, 1);
        }
      });
    }
    data[index]["AE"] = aeArr;

    let newStr = [];
    data.forEach((row) => {
      if (row.AE) {
        // newStr.push(...row.AE)
        row.AE.forEach((value) => {
          newStr.push(`${value}[${row.arrAE.shortname}]`);
        });
      }
    });
    this.setState({ data, partsFromAE: newStr.toString() }, () => {
      if (this.state.partsFromAE.length > 0) {
        if (this.state.UserEnteredSparePartsDetails.length > 0) {
          fullData.SparePartDetails =
            this.state.UserEnteredSparePartsDetails +
            "," +
            " " +
            this.state.partsFromAE;
        } else {
          fullData.SparePartDetails = this.state.partsFromAE
            .split(",")
            .join(", ");
        }
      } else {
        fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails;
      }
      fullData.UserEnteredSparePartsDetails =
        this.state.UserEnteredSparePartsDetails;
      this.setState({ fullData }, () => {
        // this.saveChanges();
      });
    });
  };

  getKleinMaterial = () => {
    const { data } = this.state;
    let kleinmaterial = 0;
    if (data) {
      kleinmaterial =
        ((isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW()) *
          this.state.PricePerHour *
          0.1 *
          5 +
          (isNaN(this.getAddedTotalDisassemblyAssemblyAW())
            ? 0
            : this.getAddedTotalDisassemblyAssemblyAW()) *
            this.state.DisassemblyAssemblyPricePerHour *
            0.1 *
            5) /
          100 >
        100
          ? 100
          : ((isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW()) *
              this.state.PricePerHour *
              0.1 *
              5 +
              (isNaN(this.getAddedTotalDisassemblyAssemblyAW())
                ? 0
                : this.getAddedTotalDisassemblyAssemblyAW()) *
                this.state.DisassemblyAssemblyPricePerHour *
                0.1 *
                5) /
            100;
    }
    kleinmaterial = this.roundOfFiveAfterDecimal(kleinmaterial);
    return kleinmaterial.toFixed(2);
  };

  getTrunkAW = (sizeA, sizeB, type, sizeC) => {
    const { data } = this.state;
    let UpdatedAwa = [];
    PricesZH.forEach((price) => {
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    });
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesZH.reduce((prev, curr) => {
        return Math.abs(curr.val - parseInt(sizeA)) <
          Math.abs(prev.val - parseInt(sizeA))
          ? curr
          : prev;
      });
    }

    if (sizeC !== undefined) {
      sizeB = sizeB + sizeC;
    }

    //getting AWb
    let UpdatedAwb = [];
    PricesZH.forEach((price) => {
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    });
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesZH.reduce((prev, curr) => {
        return Math.abs(curr.val - parseInt(sizeB)) <
          Math.abs(prev.val - parseInt(sizeB))
          ? curr
          : prev;
      });
    }

    // data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
    // data[findWithAttr(data, 'Part', 'TrunkCover')]['AWb'] = 0

    if (type === "AWa") {
      data[findWithAttr(data, "Part", "TrunkCover")]["AWa"] = UpdatedAwa[0].AWa;
      // data[findWithAttr(data, 'Part', 'TrunkCover')]["AW"] = data[findWithAttr(data, 'Part', 'TrunkCover')]['AWa'] + data[findWithAttr(data, 'Part', 'TrunkCover')]['AWb']+ this.getAluLakAddedAW(data[findWithAttr(data, 'Part', 'TrunkCover')]);
      return UpdatedAwa[0].AWa;
    } else if (type === "AWb") {
      data[findWithAttr(data, "Part", "TrunkCover")]["AWb"] = UpdatedAwb[0].AWb;
      // data[findWithAttr(data, 'Part', 'TrunkCover')]["AW"] = data[findWithAttr(data, 'Part', 'TrunkCover')]['AWa'] + data[findWithAttr(data, 'Part', 'TrunkCover')]['AWb'];
      // data[findWithAttr(data, 'Part', 'TrunkCover')]["AW"] = this.getOriginalAW( sizeA, sizeB, data[findWithAttr(data, 'Part', 'TrunkCover')]['AWa'], data[findWithAttr(data, 'Part', 'TrunkCover')]['AWb'],data[findWithAttr(data, 'Part', 'TrunkCover')]['C'],data[findWithAttr(data, 'Part', 'TrunkCover')]['AWc'],'TrunkCover') + this.getAluLakAddedAW(data[findWithAttr(data, 'Part', 'TrunkCover')]);
      data[findWithAttr(data, "Part", "TrunkCover")]["AW"] =
        this.getAluLakAddedAW(data[findWithAttr(data, "Part", "TrunkCover")]);
      return UpdatedAwb[0].AWb;
    }
  };

  getAmount = () => {
    var Amount = isNaN(this.getAddedTotalAW())
      ? 0
      : this.getAddedTotalAW() * this.state.PricePerHour * 0.1;
    Amount = this.roundOfFiveAfterDecimal(Amount);
    Amount = Intl.NumberFormat("it-CH", {
      currency: "CHF",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Amount.toFixed(2));
    // repairCost = repairCost.replace(".", ",");
    return Amount;
  };

  getPartsFromAE = (AE) => {
    // for Translate word of A + E in foooter
    let translationArr = [];
    //Replace "[" with '#['
    let partsAEArr = AE.replaceAll("[", "#[");
    //Replace ',' with '#'
    partsAEArr = partsAEArr.replaceAll(",", "#");
    // word splir from '#'
    partsAEArr = partsAEArr.split("#");
    partsAEArr.forEach((val, i) => {
      if (i === 0 || i % 2 === 0) {
        // set A + E and part name
        translationArr.push(`${this.lang(partsAEArr[i])}${partsAEArr[i + 1]}`);
      }
    });
    // array convert in string and return
    return translationArr.toString();

    // With Added sparePartsDetails
    // let translationArr = [];
    // let SplitArr = AE.split(',')
    // SplitArr.map((obj,idx) => {
    //   if(obj.includes('[')){
    //     let partsAEArr = obj.replaceAll('[','#[')
    //     //Replace ',' with '#'
    //     partsAEArr = partsAEArr.replaceAll(',','#')
    //     // word splir from '#'
    //     partsAEArr = partsAEArr.split("#")
    //     partsAEArr.forEach((val,i) => {
    //       if((i === 0) || ((i % 2) === 0)) {
    //         // set A + E and part name
    //         translationArr.push(`${this.lang(partsAEArr[i])}${partsAEArr[i+1]}`)
    //       }
    //     })
    //   }else {
    //     translationArr.push(obj)
    //   }
    // })
    // return translationArr.toString()
  };

  // toggle = (partName, showImg) => {
  //   if(showImg){
  //     this.setState({
  //       modal: !this.state.modal,
  //       imgPartName : partName
  //     },()=>{
  //       if(partName != ''){
  //         let finalPartData = this.state.data.filter((r) => r.Part == partName)[0];
  //         this.setState({
  //           Platic_part : finalPartData.Plastic
  //         })
  //       }
  //     }
  //     );
  //   } else {
  //     this.setState({
  //       modal : !this.state.modal
  //     })
  //   }
  // }
  toggle = (partName, showImg, isPlastic) => {
    if (showImg) {
      const images = (configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? this.state.imageArrDamage : this.state.imageArr;
      const imageArr = images && images.length > 0 && images.filter((image) => {
        const spiltUrl = image.split("/")[(configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? 7 : 6];
          const part = isPlastic
            ? spiltUrl && spiltUrl.split("_")[0]
            : spiltUrl && spiltUrl.split("_")[1];
          return part === partName;
        });
      this.setState({
        modal: !this.state.modal,
        imgPartName: partName,
        currentImageIndex: 0,
        filteredImages: imageArr,
      });
    } else {
      this.setState({
        modal: !this.state.modal,
      });
    }
  };

  getTotalDisassemblyAssemblyAW = () => {
    const { data } = this.state;
    const total =
      data &&
      data.reduce((acc, num) => {
        if (
          num.Part !== "Trunk" &&
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          return (
            parseFloat(acc) +
            parseFloat(
              num.disassemblyAssemblyAW && num.disassemblyAssembly
                ? num.disassemblyAssemblyAW
                : 0
            )
          );
        } else {
          return parseFloat(acc).toFixed(2);
        }
      }, 0);
    return parseFloat(total).toFixed(2);
  };

  getAddedTotalDisassemblyAssemblyAW = () => {
    const { dismantling } = this.state;
    // const total = parseFloat(dismantling) + parseFloat(this.getTotalDisassemblyAssemblyAW());
    const total = parseFloat(this.getTotalDisassemblyAssemblyAW());
    return total.toFixed(2);
  };

  getDisassemblyAssemblyAmount = () => {
    var Amount = isNaN(this.getAddedTotalDisassemblyAssemblyAW())
      ? 0
      : this.getAddedTotalDisassemblyAssemblyAW() *
        this.state.DisassemblyAssemblyPricePerHour *
        0.1;
    Amount = this.roundOfFiveAfterDecimal(Amount);
    Amount = Intl.NumberFormat("it-CH", {
      currency: "CHF",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Amount.toFixed(2));
    return Amount;
  };
  render() {
    const dynamic_Table_Colors = {
      "--table-even-color": this.state.rgbaColor || "#E8F3FF",
      "--table-header-color": this.state.insuaranceProvider.PrimaryColor || this.state.PrimaryColor || "#D80707",
      "--table-footer-color": this.state.insuaranceProvider.SecondaryColor || this.state.SecondaryColor || "#000",
      "--table-header-text-color": this.state.insuaranceProvider.HeaderTextColor || this.state.PrimaryTextColor || "#000",
      "--table-footer-text-color": this.state.insuaranceProvider.FooterTextColor || this.state.SecondaryTextColor || "#fff",
    };
    const lang = localStorage.getItem("lang");
    const {
      data,
      ALUPercentage,
      LAKPercentage,
      imgPartName,
      modal,
      disassemblyAssemblyValue,
    } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const { Authorized, viewType } = this.props;
    function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }
    let srNo = 0;
    let platic_count = 0;
    let arr =
      data &&
      data.map((obj) => {
        if (
          obj.Part !== "Trunk" &&
          obj.Part !== "LeftFrontTyre" &&
          obj.Part !== "LeftBackTyre" &&
          obj.Part !== "RightFrontTyre" &&
          obj.Part !== "RightBackTyre" &&
          obj.Part !== "FrontBumper" &&
          obj.Part !== "BackBumper" &&
          obj.Part !== "Underbody" &&
          obj.Part !== "Inside"
        ) {
          if (obj.Plastic == true) {
            platic_count++;
          }
        }
      });
    let arr_part = [
      "Hood",
      "TrunkCover",
      "LeftFrontFender",
      "RightFrontFender",
    ];

    return (
      <>
        <div
          className={`all-price-table-wrapper swiss_price_table_all ${
            this.props.viewType === "TabView" ? "container-fluid" : "container"
          } `}
        >
          <div className="row p-0">
            <div className="col-12 p-0">
              <div className="row align-items-end dns-price-table-row">
                <div
                  className={`col-${
                    this.props.viewType === "TabView" ? "8" : "12"
                  } p-0`}
                >
                  {this.props.viewType === "DAT" ? (
                    <h3 className="report-title">
                      {this.lang("Dent report")}{" "}
                      <span>{this.lang("SCANNER for repair calculation")}</span>{" "}
                      <span>{this.lang("Silver DAT or Audatex")}</span>
                    </h3>
                  ) : (
                    <h3 className="report-title">
                      {this.lang(lang === "it" ? "Calculation" : "Repair")}{" "}
                      <span>
                        {this.lang(lang === "it" ? "Repair" : "Calculation")}
                      </span>
                    </h3>
                  )}
                  {/* <h5 className="sub-title-tag">
                       {this.lang(viewType === 'DAT' ? "VFFS calculation table for spinning and drawing technology 2018" : "VFFS calculation table for spinning and drawing technology 2018")} 
                      </h5> */}
                  <div className="table-subTitle">
                    <h5 className="sub-title-tag" style={{ fontWeight: 400 }}>
                      {this.lang("zurichPriceTableTitle")}{" "}
                    </h5>
                  </div>
                </div>
                {this.props.viewType === "TabView" && (
                  <div className="col-4 text-right p-0">
                    <button
                      //  className='SubmitBut'
                      id="updateTable"
                      style={{
                        // padding:'5px',
                        backgroundColor: "#F20000",
                        padding: "5px 10px",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        fontSize: "16px",
                      }}
                      disabled={Authorized}
                      onClick={this.handleSave}
                    >
                      {this.lang("Update Table")}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className={`row dns-rice-table-row  ${
              this.props.viewType === "TabView"
                ? "arrow_table_main_wrapper"
                : ""
            }`}
          >
            <div className="col-lg-12 p-0">
              <table
                width="100%"
                border={0}
                className={`table ${
                  this.props.viewType === "TabView"
                    ? "tab_view_table new-tab-view-top-table"
                    : ""
                } table-responsive w-100`}
              >
                <thead className="w-100">
                  <tr>
                    <th
                      style={dynamic_Table_Colors}
                      rowSpan={2}
                      className={`both-top-border ${
                        this.props.viewType === "TabView"
                          ? "thead_bottom_border"
                          : ""
                      }`}
                      width={this.props.viewType === "TabView" ? "10%" : "15%"}
                    >
                      {this.lang("DamageDescription")}
                    </th>

                    {this.props.viewType === "TabView" && (
                      <>
                        <th rowSpan={2} className="empty_row"></th>

                        <th
                          rowSpan={2}
                          style={dynamic_Table_Colors}
                          width={"6%"}
                          className={`both-top-border ${
                            this.props.viewType === "TabView"
                              ? "dark-gray-col thead_bottom_border"
                              : ""
                          }`}
                        >
                          {this.lang("plastic")}
                        </th>
                      </>
                    )}
                    <th className="empty_row"></th>

                    <th
                      className={`both-top-border ${
                        this.props.viewType === "TabView"
                          ? "light-gray-col"
                          : ""
                      }`}
                      style={dynamic_Table_Colors}
                      width={"4%"}
                      colSpan={this.props.viewType === "TabView" ? 3 : 2}
                    >
                      {this.lang("Size")}
                    </th>

                    <th className="empty_row"></th>

                    <th
                      colSpan={1}
                      rowSpan={2}
                      style={dynamic_Table_Colors}
                      width={"6%"}
                      className={`both-top-border ${
                        this.props.viewType === "TabView"
                          ? "dark-gray-col thead_bottom_border"
                          : ""
                      }`}
                    >
                      {this.lang("AW")}
                    </th>

                    <th colSpan={1} rowSpan={2} className="empty_row"></th>

                    {this.props.viewType === "TabView" && (
                      <th
                        style={dynamic_Table_Colors}
                        className={`top-left-border ${
                          this.props.viewType === "TabView" ? "yellow-col" : ""
                        }`}
                      >
                        {this.lang("Oversizes")}
                      </th>
                    )}

                    {/* {this.props.viewType !== 'DAT' && */}
                    <>
                      <th
                        style={dynamic_Table_Colors}
                        width={"6%"}
                        className={`${
                          this.props.viewType === "TabView"
                            ? "orange-col"
                            : this.props.viewType === "DAT"
                            ? "both-top-border"
                            : ""
                        }`}
                        colSpan={this.props.viewType === "TabView" ? 2 : 1}
                      >
                        {this.lang("Alu")}
                      </th>
                       {this.props.viewType === "DAT" && (
                        <th className="empty_row"></th>
                      )}

                      {/* {this.props.viewType === "TabView" && ( */}
                        <th
                          style={dynamic_Table_Colors}
                          width={"4%"}
                          className={`${
                            this.props.viewType === "TabView"
                              ? "dark-gray-col top-right-border"
                               : this.props.viewType === "DAT"
                            ? "both-top-border"
                              : ""
                          }`}
                          colSpan={this.props.viewType === "TabView" ? 2 : 1}
                        >
                          {this.lang("KT")}
                        </th>
                     
                    </>

                    {/* } */}

                    {this.props.viewType != "TabView" && (
                      <th className="empty_row"></th>
                    )}

                    {this.props.viewType === "TabView" && (
                      <>
                        <th className="empty_row"></th>

                        <th
                          style={dynamic_Table_Colors}
                          width={"6%"}
                          className={`top-left-border ${
                            this.props.viewType === "TabView" ? "blue-col" : ""
                          }`}
                        >
                          {this.lang("Replace")}
                        </th>

                        <th
                          style={dynamic_Table_Colors}
                          width={"4%"}
                          className={`${
                            this.props.viewType === "TabView" ? "blue-col" : ""
                          }`}
                        >
                          {this.lang("Preprints")}
                        </th>

                        <th
                          style={dynamic_Table_Colors}
                          width={"6%"}
                          rowSpan={2}
                          className={`top-right-border min-width-100 ${
                            this.props.viewType === "TabView"
                              ? "blue-col thead_bottom_border"
                              : ""
                          }`}
                        >
                          {this.lang("AW")}
                        </th>
                      </>
                    )}

                    {this.props.viewType == "DAT" && (
                      <th
                        style={dynamic_Table_Colors}
                        width={"6%"}
                        className={`both-top-border ${
                          this.props.viewType === "TabView" ? "" : ""
                        }`}
                      >
                        <span style={{ marginBottom: "0px" }}>
                          {this.lang("Replace")}
                        </span>
                        <span style={{ marginBottom: "0px" }}>
                          {this.lang("Preprints")}
                        </span>
                      </th>
                    )}

                    {/* <th style={{width:"4%"}} colSpan={this.props.viewType === "TabView" ? 2 : 1}>{this.lang("Gr-Flache")}</th> */}

                    {(this.props.viewType === "TabView" ||
                      this.props.viewType === "DAT") && (
                      <th className="empty_row"></th>
                    )}

                    <th
                      style={dynamic_Table_Colors}
                      className="both-top-border"
                    >
                      {this.lang("totalPress")}
                    </th>

                    {this.props.viewType != "DAT" && (
                      <th className="empty_row"></th>
                    )}

                    {this.props.viewType != "DAT" && (
                      <th
                        style={dynamic_Table_Colors}
                        width={"2%"}
                        className={
                          this.props.viewType === "TabView"
                            ? "both-top-border"
                            : "table-last-row-total both-top-border"
                        }
                        colSpan={this.props.viewType === "TabView" ? 2 : 1}
                      >
                        {this.lang("disassemblyAndAssembly")}
                      </th>
                    )}
                    {/* <th style={{width:"2%"}} className={this.props.viewType === "TabView" ? "" : "table-last-row-total"}   colSpan={this.props.viewType === "TabView" ? 2 : 1}>{this.lang("disassemblyAndAssembly")}</th> */}
                    {this.props.viewType === "TabView" && (
                      <th className="empty_row"></th>
                    )}

                    {this.props.viewType === "TabView" && (
                      <>
                        <th
                          style={dynamic_Table_Colors}
                          width={"8%"}
                          className={`both-top-border ${
                            this.props.viewType === "TabView" ? "green-col" : ""
                          }`}
                          colSpan={2}
                        >
                          {this.lang("Replace")}
                        </th>
                        {/* <th colSpan={2}>{this.lang("Replace")}</th> */}
                      </>
                    )}
                  </tr>

                  <tr>
                    <th className="empty_row"></th>

                    <th
                      className={`text-center min-width-100 ${
                        this.props.viewType === "TabView"
                          ? "light-gray-col thead_bottom_border"
                          : ""
                      }`}
                      style={dynamic_Table_Colors}
                      width={"5%"}
                    >
                      {
                        // this.lang('A')
                        "< 20mm"
                      }
                    </th>
                    <th
                      className={`text-center min-width-100 ${
                        this.props.viewType === "TabView"
                          ? "light-gray-col thead_bottom_border"
                          : ""
                      }`}
                      style={dynamic_Table_Colors}
                      width={"5%"}
                    >
                      {/* {this.lang('B')} */}
                      {"> 20mm"}
                    </th>

                    {this.props.viewType === "TabView" && (
                      <th
                        className={`text-center min-width-100 ${
                          this.props.viewType === "TabView"
                            ? "light-gray-col thead_bottom_border"
                            : ""
                        }`}
                        style={dynamic_Table_Colors}
                        width={"5%"}
                      >
                        {this.lang("UG")}
                      </th>
                    )}
                    <th className="empty_row"></th>

                    {/* <th className="text-center" style={{width:"3%"}}>{this.lang("A")}</th>
                           <th className="text-center" style={{width:"3%"}}>{this.lang('B')}</th> */}
                    {/* <th className="text-center" style={{width:"6%"}}></th> */}
                    {/* <th className="empty_row"></th> */}

                    {this.props.viewType === "TabView" && (
                      <th
                        className={`text-center ${
                          this.props.viewType === "TabView"
                            ? "yellow-col thead_bottom_border"
                            : ""
                        }`}
                        style={dynamic_Table_Colors}
                        width={"3%"}
                      >
                        {this.lang("AW")}
                      </th>
                    )}
                    {/* {this.props.viewType !== 'DAT' && */}

                    {this.props.viewType === "TabView" && (
                      <th
                        style={dynamic_Table_Colors}
                        className={`text-center ${
                          this.props.viewType === "TabView"
                            ? "orange-col thead_bottom_border"
                            : ""
                        }`}
                      >
                        X
                      </th>
                    )}
                    <th
                      className={`text-center ${
                        this.props.viewType === "TabView"
                          ? "orange-col thead_bottom_border"
                          : ""
                      }`}
                      style={dynamic_Table_Colors}
                      width={"3%"}
                    >
                      {this.state.ALUPercentage &&
                        `(+${parseInt(this.state.ALUPercentage)}%)`}
                    </th>
                    {
                      this.props.viewType === "DAT" && (
                    <th className="empty_row"></th>
                      )
                    }

                    {this.props.viewType === "TabView" && (
                      <>
                        <th
                          className={`text-center ${
                            this.props.viewType === "TabView"
                              ? "dark-gray-col thead_bottom_border"
                              : ""
                          }`}
                          style={dynamic_Table_Colors}
                        >
                          X
                        </th>
                        </>
                      )}

                        <th
                          className={`text-center ${
                            this.props.viewType === "TabView"
                              ? "dark-gray-col thead_bottom_border"
                              : ""
                          }`}
                          style={dynamic_Table_Colors}
                        >
                          {this.state.LAKPercentage &&
                            `(+${parseInt(this.state.LAKPercentage)}%)`}
                        </th>
                    {/* } */}
                    {/* {this.props.viewType === 'TabView' && <th className="text-center">X</th>}
                           <th className="text-center">(+25%)</th> */}

                    {this.props.viewType === "TabView" && (
                      <th className="text-center empty_row"></th>
                    )}

                    {this.props.viewType === "TabView" && (
                      <>
                        <th
                          className={`text-center ${
                            this.props.viewType === "TabView"
                              ? "blue-col thead_bottom_border"
                              : ""
                          }`}
                          style={dynamic_Table_Colors}
                        >
                          X
                        </th>

                        <th
                          className={`text-center ${
                            this.props.viewType === "TabView"
                              ? "blue-col thead_bottom_border"
                              : ""
                          }`}
                          style={dynamic_Table_Colors}
                        >
                          X
                        </th>
                      </>
                    )}

                    {this.props.viewType == "DAT" && (
                      <>
                        <th className="empty_row"></th>

                        <th style={dynamic_Table_Colors} width={"4%"}>
                          {this.lang("AW")}
                        </th>
                      </>
                    )}

                    {(this.props.viewType === "TabView" ||
                      this.props.viewType === "DAT") && (
                      <th className="empty_row"></th>
                    )}

                    <th
                      className="text-center thead_bottom_border"
                      style={dynamic_Table_Colors}
                      width={"6%"}
                    >
                      {this.lang("AW")}
                    </th>

                    {this.props.viewType != "DAT" && (
                      <th className="text-center empty_row"></th>
                    )}

                    {this.props.viewType != "DAT" &&
                      this.props.viewType === "TabView" && (
                        <th
                          className={`text-center ${
                            this.props.viewType === "TabView"
                              ? "thead_bottom_border"
                              : ""
                          }`}
                          style={dynamic_Table_Colors}
                        >
                          X
                        </th>
                      )}

                    {this.props.viewType != "DAT" && (
                      <th
                        className={`text-center ${
                          this.props.viewType === "TabView"
                            ? "thead_bottom_border"
                            : ""
                        }`}
                        style={dynamic_Table_Colors}
                      >
                        {this.lang("AW")}
                      </th>
                    )}

                    {this.props.viewType === "TabView" && (
                      <th className="empty_row"></th>
                    )}

                    {this.props.viewType === "TabView" && (
                      <>
                        <th
                          className={`text-center ${
                            this.props.viewType === "TabView"
                              ? "green-col thead_bottom_border"
                              : ""
                          }`}
                          style={dynamic_Table_Colors}
                        >
                          X
                        </th>
                        <th
                          className={`text-center ${
                            this.props.viewType === "TabView"
                              ? "green-col thead_bottom_border"
                              : ""
                          }`}
                          style={dynamic_Table_Colors}
                          width={"6%"}
                        ></th>
                        {/* <th className="text-center">X</th>
                            <th className="text-center"></th> */}
                      </>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {data &&
                    data.map((row, index) => {
                      if (row.Part !== "Trunk") {
                        srNo = srNo + 1;
                      }
                      return (
                        row.Part !== "Trunk" &&
                        row.Part !== "LeftFrontTyre" &&
                        row.Part !== "LeftBackTyre" &&
                        row.Part !== "RightFrontTyre" &&
                        row.Part !== "RightBackTyre" &&
                        row.Part !== "FrontBumper" &&
                        row.Part !== "BackBumper" &&
                        row.Part !== "Underbody" &&
                        row.Part !== "Inside" && (
                          <tr key={index} className="top-table-body">
                            {/* part */}
                            <td
                              style={dynamic_Table_Colors}
                              className="parts_name_row price-tbody-td"
                            >
                              <p
                                className="m-0"
                                onClick={() =>
                                  this.props.viewType === "TabView" &&
                                  this.toggle(row.Part, true, row.Plastic)
                                }
                                style={{
                                  cursor: "pointer",
                                  textDecoration:
                                    this.props.viewType === "TabView"
                                      ? "underline"
                                      : "",
                                }}
                              >
                                {this.lang(row.Part)}
                              </p>
                            </td>

                            {this.props.viewType === "TabView" && (
                              <>
                                <td className="empty_row"></td>

                                {/* Plastic */}

                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-center ${
                                    this.props.viewType === "TabView"
                                      ? "dark-gray-col"
                                      : ""
                                  } `}
                                >
                                  {row.Part === "TrunkCover" &&
                                  data[findWithAttr(data, "Part", "Trunk")] ? (
                                    this.props.viewType === "TabView" ? (
                                      <input
                                        type="checkbox"
                                        className="cross_input"
                                        checked={
                                          row.Plastic ||
                                          data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ].Plastic
                                        }
                                        disabled={Authorized}
                                        onChange={(e) => {
                                          this.change(
                                            row.Part,
                                            e,
                                            index,
                                            "Plastic"
                                          );
                                        }}
                                      />
                                    ) : row.Plastic ? (
                                      <span style={{ fontSize: "16px" }}>
                                        <i className="fa fa-check"></i>
                                      </span>
                                    ) : (
                                      ""
                                    )
                                  ) : this.props.viewType === "TabView" ? (
                                    <input
                                      type="checkbox"
                                      className="cross_input"
                                      checked={row.Plastic}
                                      disabled={Authorized}
                                      onChange={(e) => {
                                        this.change(
                                          row.Part,
                                          e,
                                          index,
                                          "Plastic"
                                        );
                                      }}
                                    />
                                  ) : row.Plastic ? (
                                    <span style={{ fontSize: "16px" }}>
                                      <i className="fa fa-check"></i>
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </>
                            )}

                            <td className="empty_row"></td>
                            {/* dents */}
                            {/* {row.A} */}

                            <td
                              style={dynamic_Table_Colors}
                              className={`text-center price-tbody-td ${
                                this.props.viewType === "TabView"
                                  ? "light-gray-col"
                                  : ""
                              }`}
                            >
                              {row.Part === "TrunkCover" &&
                              data[findWithAttr(data, "Part", "Trunk")] ? (
                                this.props.viewType === "TabView" ? (
                                  this.state.loadedFirstTimeA ? (
                                    <div
                                      style={{
                                        position: "relative",
                                        width: "100%",
                                      }}
                                    >
                                      <input
                                        name="A"
                                        type="number"
                                        min="0"
                                        className="price-table-input"
                                        style={{
                                          width: "100%",
                                          border: "none",
                                          outline: "none",
                                          textAlign: "center",
                                          color: `${
                                            row.TotalDents > 607 ? "red" : ""
                                          }`,
                                        }}
                                        value={
                                          row.Plastic
                                            ? 0
                                            : data[index]["A"] +
                                              data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ]["A"]
                                        }
                                        onChange={(e) => {
                                          this.hadnleDentsChanges(
                                            row.Part,
                                            e,
                                            index,
                                            "loadedFirstTimeA"
                                          );
                                        }}
                                        disabled={Authorized}
                                      />
                                      {!Authorized && (
                                        <>
                                          <div className="button-table-arrow-position">
                                            <button
                                              onClick={() => {
                                                const updatedValue = Math.max(
                                                  data[index]["A"] - 1,
                                                  0
                                                );
                                                this.hadnleDentsChanges(
                                                  row.Part,
                                                  {
                                                    target: {
                                                      name: "A",
                                                      value: updatedValue,
                                                    },
                                                  },
                                                  index,
                                                  "loadedFirstTimeA"
                                                );
                                              }}
                                              className="decrement-button"
                                            >
                                              -
                                            </button>
                                            <button
                                              onClick={() => {
                                                const updatedValue =
                                                  data[index]["A"] + 1;
                                                this.hadnleDentsChanges(
                                                  row.Part,
                                                  {
                                                    target: {
                                                      name: "A",
                                                      value: updatedValue,
                                                    },
                                                  },
                                                  index,
                                                  "loadedFirstTimeA"
                                                );
                                              }}
                                              className="increment-button"
                                            >
                                              +
                                            </button>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <>
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                        }}
                                      >
                                        <input
                                          name="A"
                                          type="number"
                                          min="0"
                                          className="price-table-input"
                                          style={{
                                            width: "100%",
                                            border: "none",
                                            outline: "none",
                                            textAlign: "center",
                                            color: `${
                                              row.TotalDents > 607 ? "red" : ""
                                            }`,
                                          }}
                                          value={
                                            row.Plastic ? 0 : data[index]["A"]
                                          }
                                          onChange={(e) => {
                                            this.hadnleDentsChanges(
                                              row.Part,
                                              e,
                                              index
                                            );
                                          }}
                                          disabled={Authorized}
                                        />
                                        {!Authorized && (
                                          <>
                                            <div className="button-table-arrow-position">
                                              <button
                                                onClick={() => {
                                                  const updatedValue = Math.max(
                                                    data[index]["A"] - 1,
                                                    0
                                                  );
                                                  this.hadnleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "A",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index,
                                                    "loadedFirstTimeA"
                                                  );
                                                }}
                                                className="decrement-button"
                                              >
                                                -
                                              </button>
                                              <button
                                                onClick={() => {
                                                  const updatedValue =
                                                    data[index]["A"] + 1;
                                                  this.hadnleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "A",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index,
                                                    "loadedFirstTimeA"
                                                  );
                                                }}
                                                className="increment-button"
                                              >
                                                +
                                              </button>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )
                                ) : (
                                  <p>
                                    {row.Plastic
                                      ? 0
                                      : data[index]["A"] +
                                        data[
                                          findWithAttr(data, "Part", "Trunk")
                                        ]["A"]}
                                  </p>
                                )
                              ) : this.props.viewType === "TabView" ? (
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <input
                                    name="A"
                                    type="number"
                                    min="0"
                                    className="price-table-input"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                      color: `${
                                        row.TotalDents > 607 ? "red" : ""
                                      }`,
                                    }}
                                    value={row.Plastic ? 0 : data[index]["A"]}
                                    onChange={(e) => {
                                      this.hadnleDentsChanges(
                                        row.Part,
                                        e,
                                        index
                                      );
                                    }}
                                    disabled={Authorized}
                                  />
                                  {!Authorized && (
                                    <>
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max(
                                              data[index]["A"] - 1,
                                              0
                                            );
                                            this.hadnleDentsChanges(
                                              row.Part,
                                              {
                                                target: {
                                                  name: "A",
                                                  value: updatedValue,
                                                },
                                              },
                                              index
                                            );
                                          }}
                                          className="decrement-button"
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue =
                                              data[index]["A"] + 1;
                                            this.hadnleDentsChanges(
                                              row.Part,
                                              {
                                                target: {
                                                  name: "A",
                                                  value: updatedValue,
                                                },
                                              },
                                              index
                                            );
                                          }}
                                          className="increment-button"
                                        >
                                          +
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              ) : (
                                <p>{row.Plastic ? 0 : data[index]["A"]}</p>
                              )}
                            </td>
                            {/* {row.B} */}

                            <td
                              style={dynamic_Table_Colors}
                              className={`text-center price-tbody-td ${
                                this.props.viewType === "TabView"
                                  ? "light-gray-col"
                                  : ""
                              }`}
                            >
                              {row.Part === "TrunkCover" &&
                              data[findWithAttr(data, "Part", "Trunk")] ? (
                                this.props.viewType === "TabView" ? (
                                  this.state.loadedFirstTimeB ? (
                                    <div
                                      style={{
                                        position: "relative",
                                        width: "100%",
                                      }}
                                    >
                                      <input
                                        className="price-table-input"
                                        name="B"
                                        type="number"
                                        min="0"
                                        style={{
                                          width: "100%",
                                          border: "none",
                                          outline: "none",
                                          textAlign: "center",
                                        }}
                                        value={
                                          row.Plastic
                                            ? 0
                                            : data[index]["B"] +
                                              (data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ]["B"]
                                                ? data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ]["B"]
                                                : 0)
                                        }
                                        onChange={(e) => {
                                          this.hadnleDentsChanges(
                                            row.Part,
                                            e,
                                            index,
                                            "loadedFirstTimeB"
                                          );
                                        }}
                                        disabled={Authorized}
                                      />
                                      {!Authorized && (
                                        <>
                                          <div className="button-table-arrow-position">
                                            <button
                                              onClick={() => {
                                                const updatedValue = Math.max(
                                                  data[index]["B"] - 1,
                                                  0
                                                );
                                                this.hadnleDentsChanges(
                                                  row.Part,
                                                  {
                                                    target: {
                                                      name: "B",
                                                      value: updatedValue,
                                                    },
                                                  },
                                                  index,
                                                  "loadedFirstTimeB"
                                                );
                                              }}
                                              className="decrement-button"
                                            >
                                              -
                                            </button>
                                            <button
                                              onClick={() => {
                                                const updatedValue =
                                                  data[index]["B"] + 1;
                                                this.hadnleDentsChanges(
                                                  row.Part,
                                                  {
                                                    target: {
                                                      name: "B",
                                                      value: updatedValue,
                                                    },
                                                  },
                                                  index,
                                                  "loadedFirstTimeB"
                                                );
                                              }}
                                              className="increment-button"
                                            >
                                              +
                                            </button>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <>
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                        }}
                                      >
                                        <input
                                          name="B"
                                          type="number"
                                          min="0"
                                          className="price-table-input"
                                          style={{
                                            width: "100%",
                                            border: "none",
                                            outline: "none",
                                            textAlign: "center",
                                          }}
                                          value={
                                            row.Plastic ? 0 : data[index]["B"]
                                          }
                                          onChange={(e) => {
                                            this.hadnleDentsChanges(
                                              row.Part,
                                              e,
                                              index
                                            );
                                          }}
                                          disabled={Authorized}
                                        />
                                        {!Authorized && (
                                          <>
                                            <div className="button-table-arrow-position">
                                              <button
                                                onClick={() => {
                                                  const updatedValue = Math.max(
                                                    data[index]["B"] - 1,
                                                    0
                                                  );
                                                  this.hadnleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "B",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index,
                                                    "loadedFirstTimeB"
                                                  );
                                                }}
                                                disabled={Authorized}
                                                className="decrement-button"
                                              >
                                                -
                                              </button>
                                              <button
                                                onClick={() => {
                                                  const updatedValue =
                                                    data[index]["B"] + 1;
                                                  this.hadnleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "B",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index,
                                                    "loadedFirstTimeB"
                                                  );
                                                }}
                                                disabled={Authorized}
                                                className="increment-button"
                                              >
                                                +
                                              </button>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )
                                ) : (
                                  <p>
                                    {row.Plastic
                                      ? 0
                                      : data[index]["B"] +
                                        data[
                                          findWithAttr(data, "Part", "Trunk")
                                        ]["B"] +
                                        ((data[index]["C"]
                                          ? data[index]["C"]
                                          : 0) +
                                          (data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ]["C"]
                                            ? data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ]["C"]
                                            : 0))}
                                  </p>
                                )
                              ) : this.props.viewType === "TabView" ? (
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <input
                                    name="B"
                                    type="number"
                                    min="0"
                                    className="price-table-input"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                    }}
                                    value={row.Plastic ? 0 : data[index]["B"]}
                                    onChange={(e) => {
                                      this.hadnleDentsChanges(
                                        row.Part,
                                        e,
                                        index
                                      );
                                    }}
                                    disabled={Authorized}
                                  />
                                  {!Authorized && (
                                    <>
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max(
                                              data[index]["B"] - 1,
                                              0
                                            );
                                            this.hadnleDentsChanges(
                                              row.Part,
                                              {
                                                target: {
                                                  name: "B",
                                                  value: updatedValue,
                                                },
                                              },
                                              index
                                            );
                                          }}
                                          disabled={Authorized}
                                          className="decrement-button"
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue =
                                              data[index]["B"] + 1;
                                            this.hadnleDentsChanges(
                                              row.Part,
                                              {
                                                target: {
                                                  name: "B",
                                                  value: updatedValue,
                                                },
                                              },
                                              index
                                            );
                                          }}
                                          disabled={Authorized}
                                          className="increment-button"
                                        >
                                          +
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              ) : (
                                <p>
                                  {row.Plastic
                                    ? 0
                                    : data[index]["B"] +
                                      (data[index]["C"] ? data[index]["C"] : 0)}
                                </p>
                              )}
                            </td>
                            {/* {row.C} */}

                            {this.props.viewType === "TabView" && (
                              <td
                                className={`text-center price-tbody-td ${
                                  this.props.viewType === "TabView"
                                    ? "light-gray-col"
                                    : ""
                                }`}
                                style={dynamic_Table_Colors}
                              >
                                {row.Part === "TrunkCover" &&
                                data[findWithAttr(data, "Part", "Trunk")] ? (
                                  this.props.viewType === "TabView" ? (
                                    this.state.loadedFirstTimeC ? (
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                        }}
                                      >
                                        <input
                                          name="C"
                                          type="number"
                                          min="0"
                                          className="price-table-input"
                                          style={{
                                            width: "100%",
                                            border: "none",
                                            outline: "none",
                                            textAlign: "center",
                                          }}
                                          value={
                                            row.Plastic
                                              ? 0
                                              : data[index]["C"] +
                                                (data[
                                                  findWithAttr(
                                                    data,
                                                    "Part",
                                                    "Trunk"
                                                  )
                                                ]["C"]
                                                  ? data[
                                                      findWithAttr(
                                                        data,
                                                        "Part",
                                                        "Trunk"
                                                      )
                                                    ]["C"]
                                                  : 0)
                                          }
                                          onChange={(e) => {
                                            this.hadnleDentsChanges(
                                              row.Part,
                                              e,
                                              index,
                                              "loadedFirstTimeC"
                                            );
                                          }}
                                          disabled={Authorized}
                                        />
                                        {!Authorized && (
                                          <>
                                            <div className="button-table-arrow-position">
                                              <button
                                                onClick={() => {
                                                  const updatedValue = Math.max(
                                                    data[index]["C"] - 1,
                                                    0
                                                  );
                                                  this.hadnleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "C",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index,
                                                    "loadedFirstTimeC"
                                                  );
                                                }}
                                                disabled={Authorized}
                                                className="decrement-button"
                                              >
                                                -
                                              </button>
                                              <button
                                                onClick={() => {
                                                  const updatedValue =
                                                    data[index]["C"] + 1;
                                                  this.hadnleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "C",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index,
                                                    "loadedFirstTimeC"
                                                  );
                                                }}
                                                disabled={Authorized}
                                                className="increment-button"
                                              >
                                                +
                                              </button>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    ) : (
                                      <>
                                        <div
                                          style={{
                                            position: "relative",
                                            width: "100%",
                                          }}
                                        >
                                          <input
                                            name="C"
                                            type="number"
                                            min="0"
                                            className="price-table-input"
                                            style={{
                                              width: "100%",
                                              border: "none",
                                              outline: "none",
                                              textAlign: "center",
                                            }}
                                            value={
                                              row.Plastic ? 0 : data[index]["C"]
                                            }
                                            onChange={(e) => {
                                              this.hadnleDentsChanges(
                                                row.Part,
                                                e,
                                                index
                                              );
                                            }}
                                            disabled={Authorized}
                                          />
                                          {!Authorized && (
                                            <>
                                              <div className="button-table-arrow-position">
                                                <button
                                                  onClick={() => {
                                                    const updatedValue =
                                                      Math.max(
                                                        data[index]["C"] - 1,
                                                        0
                                                      );
                                                    this.hadnleDentsChanges(
                                                      row.Part,
                                                      {
                                                        target: {
                                                          name: "C",
                                                          value: updatedValue,
                                                        },
                                                      },
                                                      index,
                                                      "loadedFirstTimeC"
                                                    );
                                                  }}
                                                  disabled={Authorized}
                                                  className="decrement-button"
                                                >
                                                  -
                                                </button>
                                                <button
                                                  onClick={() => {
                                                    const updatedValue =
                                                      data[index]["C"] + 1;
                                                    this.hadnleDentsChanges(
                                                      row.Part,
                                                      {
                                                        target: {
                                                          name: "C",
                                                          value: updatedValue,
                                                        },
                                                      },
                                                      index,
                                                      "loadedFirstTimeC"
                                                    );
                                                  }}
                                                  disabled={Authorized}
                                                  className="increment-button"
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </>
                                    )
                                  ) : (
                                    <p>
                                      {row.Plastic
                                        ? 0
                                        : data[index]["C"] +
                                          (data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ]["C"]
                                            ? data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ]["C"]
                                            : 0)}
                                    </p>
                                  )
                                ) : this.props.viewType === "TabView" ? (
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "100%",
                                    }}
                                  >
                                    <input
                                      name="C"
                                      type="number"
                                      min="0"
                                      className="price-table-input"
                                      style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      value={row.Plastic ? 0 : data[index]["C"]}
                                      onChange={(e) => {
                                        this.hadnleDentsChanges(
                                          row.Part,
                                          e,
                                          index
                                        );
                                      }}
                                      disabled={Authorized}
                                    />

                                    {!Authorized && (
                                      <>
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max(
                                                data[index]["C"] - 1,
                                                0
                                              );
                                              this.hadnleDentsChanges(
                                                row.Part,
                                                {
                                                  target: {
                                                    name: "C",
                                                    value: updatedValue,
                                                  },
                                                },
                                                index
                                              );
                                            }}
                                            disabled={Authorized}
                                            className="decrement-button"
                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue =
                                                data[index]["C"] + 1;
                                              this.hadnleDentsChanges(
                                                row.Part,
                                                {
                                                  target: {
                                                    name: "C",
                                                    value: updatedValue,
                                                  },
                                                },
                                                index
                                              );
                                            }}
                                            disabled={Authorized}
                                            className="increment-button"
                                          >
                                            +
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                ) : (
                                  <p>{row.Plastic ? 0 : data[index]["C"]}</p>
                                )}
                              </td>
                            )}
                            <td className="empty_row"></td>
                            {/* OriginalAW */}
                            <td
                              style={dynamic_Table_Colors}
                              className={`text-center price-tbody-td ${
                                this.props.viewType === "TabView"
                                  ? "dark-gray-col"
                                  : ""
                              }`}
                            >
                              <p>
                                {row.Part === "TrunkCover"
                                  ? row.Plastic
                                    ? "0.00"
                                    : this.getOriginalAW(
                                        (row.A ? row.A : 0) +
                                          (data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ].A
                                            ? data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].A
                                            : 0),
                                        (row.B ? row.B : 0) +
                                          (data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ].B
                                            ? data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].B
                                            : 0),
                                        row.AWa,
                                        row.AWb,
                                        (row.C ? row.C : 0) +
                                          (data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ].C
                                            ? data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].C
                                            : 0)
                                      ).toFixed(2)
                                  : // (this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0))
                                  row.Plastic
                                  ? "0.00"
                                  : this.getOriginalAW(
                                      row.A,
                                      row.B,
                                      row.AWa,
                                      row.AWb,
                                      row.C
                                    ).toFixed(2)}
                              </p>
                            </td>
                            {/* AWa 
                                  <td className={"text-center"}>
                                    {(row.Part === "TrunkCover" && data[findWithAttr(data, 'Part', 'Trunk')]) ?
                                        // row.AWa + data[findWithAttr(data, 'Part', 'TrunkCover')].AWa
                                        data && this.getTrunkAW(row.A + data[findWithAttr(data, 'Part', 'Trunk')].A , row.B + data[findWithAttr(data, 'Part', 'Trunk')].B,'AWa')
                                      :
                                        <p>{row.AWa}</p>
                                    }
                                  </td>
                                  //AWb 
                                  <td className={"text-center" }>
                                    {(row.Part === "TrunkCover" && data[findWithAttr(data, 'Part', 'Trunk')]) ?
                                        // row.AWb + data[findWithAttr(data, 'Part', 'Trunk')].AWb
                                        data && this.getTrunkAW(row.A + data[findWithAttr(data, 'Part', 'Trunk')].A , row.B + data[findWithAttr(data, 'Part', 'Trunk')].B,'AWb',((row.C ? row.C : 0 )+ (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0)))
                                      :
                                        <p>{row.AWb}</p>
                                    }
                                  </td>
                                  */}
                            <td className="empty_row"></td>
                            {/* AWc */}
                            {this.props.viewType === "TabView" && (
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td text-center ${
                                  this.props.viewType === "TabView"
                                    ? "yellow-col"
                                    : ""
                                }`}
                              >
                                {row.Part === "TrunkCover" &&
                                data[findWithAttr(data, "Part", "Trunk")] ? (
                                  this.props.viewType === "TabView" ? (
                                    this.state.loadedFirstTimeAWc ? (
                                      // <div style={{ position: 'relative', width: '100%' }}>
                                      <input
                                        type="number"
                                        name="AWc"
                                        className="price-table-input"
                                        style={{
                                          width: "100%",
                                          border: "none",
                                          outline: "none",
                                          textAlign: "center",
                                        }}
                                        min="0"
                                        value={row.AWc}
                                        onChange={(e) => {
                                          this.handleAWchanges(
                                            index,
                                            e,
                                            "loadedFirstTimeAWc"
                                          );
                                        }}
                                        disabled={Authorized}
                                      />
                                    ) : (
                                      //  {!Authorized &&
                                      //   <>
                                      //   <div className="button-table-arrow-position">
                                      //   <button
                                      //     onClick={() => {
                                      //       const updatedValue = Math.max((parseInt(row.AWc) || 0) - 1, 0);
                                      //       this.handleAWchanges(index, { target: { name: 'AWc', value: updatedValue } });
                                      //     }}
                                      //     disabled={Authorized || row.Plastic}
                                      //     className="decrement-button"
                                      //   >
                                      //     -
                                      //   </button>
                                      //   <button
                                      //     onClick={() => {
                                      //       const updatedValue = (parseInt(row.AWc) || 0) + 1;
                                      //       this.handleAWchanges(index, { target: { name: 'AWc', value: updatedValue } });
                                      //     }}
                                      //     disabled={Authorized || row.Plastic}
                                      //     className="increment-button"
                                      //   >
                                      //     +
                                      //   </button>
                                      //   </div>
                                      //   </>
                                      // }
                                      // </div>
                                      <>
                                        {/* <div style={{ position: 'relative', width: '100%' }}> */}
                                        <input
                                          type="number"
                                          name="AWc"
                                          className="price-table-input"
                                          style={{
                                            width: "100%",
                                            border: "none",
                                            outline: "none",
                                            textAlign: "center",
                                          }}
                                          min="0"
                                          value={row.AWc}
                                          onChange={(e) => {
                                            this.handleAWchanges(index, e);
                                          }}
                                          disabled={Authorized}
                                        />
                                        {/* {!Authorized && 
                                     <>
                                      <div className="button-table-arrow-position">
                                      <button
                                        onClick={() => {
                                          const updatedValue = Math.max((parseInt(row.AWc) || 0) - 1, 0);
                                          this.handleAWchanges(index, { target: { name: 'AWc', value: updatedValue } });
                                        }}
                                        disabled={Authorized || row.Plastic}
                                        className="decrement-button"
                                      >
                                        -
                                      </button>
                                      <button
                                        onClick={() => {
                                          const updatedValue = (parseInt(row.AWc) || 0) + 1;
                                          this.handleAWchanges(index, { target: { name: 'AWc', value: updatedValue } });
                                        }}
                                        disabled={Authorized || row.Plastic}
                                        className="increment-button"
                                      >
                                        +
                                      </button>
                                      </div>
                                      </>
                                    }
                                    </div> */}
                                      </>
                                    )
                                  ) : (
                                    <p>
                                      {row.AWc !== 0 && row.AWc !== undefined
                                        ? row.AWc
                                        : ""}
                                    </p>
                                  )
                                ) : this.props.viewType === "TabView" ? (
                                  // <div style={{ position: 'relative', width: '100%' }}>
                                  <input
                                    type="number"
                                    className="price-table-input"
                                    name="AWc"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                    }}
                                    min="0"
                                    value={row.AWc}
                                    onChange={(e) => {
                                      this.handleAWchanges(index, e);
                                    }}
                                    disabled={Authorized}
                                  />
                                ) : (
                                  //   {!Authorized &&
                                  //   <div className="button-table-arrow-position">
                                  //   <button
                                  //     onClick={() => {
                                  //       const updatedValue = Math.max((parseInt(row.AWc) || 0) - 1, 0);
                                  //       this.handleAWchanges(index, { target: { name: 'AWc', value: updatedValue } });
                                  //     }}
                                  //     disabled={Authorized || row.Plastic}
                                  //     className="decrement-button"
                                  //   >
                                  //     -
                                  //   </button>
                                  //   <button
                                  //     onClick={() => {
                                  //       const updatedValue = (parseInt(row.AWc) || 0) + 1;
                                  //       this.handleAWchanges(index, { target: { name: 'AWc', value: updatedValue } });
                                  //     }}
                                  //     disabled={Authorized || row.Plastic}
                                  //     className="increment-button"
                                  //   >
                                  //     +
                                  //   </button>
                                  //   </div>
                                  // }
                                  // </div>
                                  <p>
                                    {row.AWc !== 0 && row.AWc !== undefined
                                      ? row.AWc
                                      : ""}
                                  </p>
                                )}
                              </td>
                            )}
                            {/* {this.props.viewType !== 'DAT' && */}
                            <>
                              {/* ALU CheckBox*/}
                              {this.props.viewType === "TabView" && (
                                <td
                                  className="text-center orange-col price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Plastic ? false : row.Alu}
                                    disabled={
                                      (row.GrFlache || row.Plastic
                                        ? true
                                        : false) || Authorized
                                    }
                                    onChange={(e) => {
                                      this.handleAluLakChanges(e, index, "Alu");
                                    }}
                                  />
                                </td>
                              )}
                              {/* Alu */}
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td text-center ${
                                  this.props.viewType === "TabView"
                                    ? "orange-col"
                                    : ""
                                }`}
                              >
                                {row.Part === "TrunkCover" ? (
                                  <p>
                                    {row.Plastic
                                      ? ""
                                      : row.Alu
                                      ? // (Math.round(((this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),row.AWa, row.AWb,(row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),row.AWc) * ALUPercentage) /100) * 100) /100).toFixed(2)
                                        this.round(
                                          (this.getOriginalAW(
                                            (row.A ? row.A : 0) +
                                              (data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].A
                                                ? data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].A
                                                : 0),
                                            (row.B ? row.B : 0) +
                                              (data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].B
                                                ? data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].B
                                                : 0),
                                            row.AWa,
                                            row.AWb,
                                            (row.C ? row.C : 0) +
                                              (data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].C
                                                ? data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].C
                                                : 0),
                                            row.AWc
                                          ) *
                                            ALUPercentage) /
                                            100
                                        ).toFixed(2)
                                      : ""}
                                  </p>
                                ) : (
                                  <p>
                                    {row.Plastic
                                      ? ""
                                      : row.Alu
                                      ? // (Math.round((this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc) * ALUPercentage / 100) * 100) / 100).toFixed(2)
                                        this.round(
                                          (this.getOriginalAW(
                                            row.A,
                                            row.B,
                                            row.AWa,
                                            row.AWb,
                                            row.C,
                                            row.AWc
                                          ) *
                                            ALUPercentage) /
                                            100
                                        ).toFixed(2)
                                      : // (((this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc)) * ALUPercentage) / 100.0).toFixed(2)
                                        ""}
                                  </p>
                                )}
                              </td>
                                {
                                  viewType == "DAT" && (
                            <td className="empty_row"></td>
                                  )
                                }
                              {/* KT checkbox*/}
                              {(this.props.viewType === "TabView") && (
                                <td
                                  style={dynamic_Table_Colors}
                                  className="text-center dark-gray-col price-tbody-td"
                                >
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Push2paint}
                                    // disabled={((row.Alu || row.GrFlache) ? true : false) || Authorized}
                                    // disabled={(( row.GrFlache) ? true : false) || Authorized}
                                    disabled={Authorized}
                                    onChange={(e) => {
                                      this.handleAluLakChanges(
                                        e,
                                        index,
                                        "Push2paint"
                                      );
                                    }}
                                  />
                                </td>
                              )}
                              {/* KT */}
                              {(this.props.viewType === "TabView" || this.props.viewType === "DAT") && (
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-center ${
                                    this.props.viewType === "TabView"
                                      ? "dark-gray-col"
                                      : ""
                                  }`}
                                >
                                  {row.Part === "TrunkCover" ? (
                                    <p>
                                      {row.Push2paint
                                        ? this.round(
                                            (this.getOriginalAW(
                                              (row.A ? row.A : 0) +
                                                (data[
                                                  findWithAttr(
                                                    data,
                                                    "Part",
                                                    "Trunk"
                                                  )
                                                ].A
                                                  ? data[
                                                      findWithAttr(
                                                        data,
                                                        "Part",
                                                        "Trunk"
                                                      )
                                                    ].A
                                                  : 0),
                                              (row.B ? row.B : 0) +
                                                (data[
                                                  findWithAttr(
                                                    data,
                                                    "Part",
                                                    "Trunk"
                                                  )
                                                ].B
                                                  ? data[
                                                      findWithAttr(
                                                        data,
                                                        "Part",
                                                        "Trunk"
                                                      )
                                                    ].B
                                                  : 0),
                                              row.AWa,
                                              row.AWb,
                                              (row.C ? row.C : 0) +
                                                (data[
                                                  findWithAttr(
                                                    data,
                                                    "Part",
                                                    "Trunk"
                                                  )
                                                ].C
                                                  ? data[
                                                      findWithAttr(
                                                        data,
                                                        "Part",
                                                        "Trunk"
                                                      )
                                                    ].C
                                                  : 0),
                                              row.AWc
                                            ) *
                                              LAKPercentage) /
                                              100
                                          ).toFixed(2)
                                        : // (Math.round(((this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),row.AWa, row.AWb,(row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),row.AWc) * LAKPercentage) /100) * 100) /100).toFixed(2)
                                          // ((this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),row.AWa, row.AWb,(row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),row.AWc) * LAKPercentage) /100).toFixed(2)
                                          ""}
                                    </p>
                                  ) : (
                                    <p>
                                      {row.Push2paint
                                        ? // (((this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc)) * LAKPercentage) / 100.0).toFixed(2)
                                          this.round(
                                            (this.getOriginalAW(
                                              row.A,
                                              row.B,
                                              row.AWa,
                                              row.AWb,
                                              row.C,
                                              row.AWc
                                            ) *
                                              LAKPercentage) /
                                              100
                                          ).toFixed(2)
                                        : ""}
                                    </p>
                                  )}

                                  {/* {(row.Part === "Trunk" && data[findWithAttr(data, 'Part', 'TrunkCover')]) ?
                                              <p>
                                                {(row.Push2paint || data[findWithAttr(data, 'Part', 'TrunkCover')].Push2paint) ? 
                                                  // (((parseFloat(this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc)) * ALUPercentage) / 100.0) + ((parseFloat(this.getOriginalAW(data[findWithAttr(data, 'Part', 'TrunkCover')].A, data[findWithAttr(data, 'Part', 'TrunkCover')].B, data[findWithAttr(data, 'Part', 'TrunkCover')].AWa, data[findWithAttr(data, 'Part', 'TrunkCover')].AWb, data[findWithAttr(data, 'Part', 'TrunkCover')].C, data[findWithAttr(data, 'Part', 'TrunkCover')].AWc)) * ALUPercentage) / 100.0))
                                                  this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc) * LAKPercentage / 100.0
                                                : 
                                                  ""}
                                              </p>
                                          :
                                              <p>
                                                {row.Push2paint ? 
                                                  ((parseFloat(this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc)) * LAKPercentage) / 100.0).toFixed(2)
                                                : 
                                                  ""}
                                              </p>
                                          }   */}
                                </td>
                              )}
                            </>
                            {/* } */}
                            {/* GrFlache Checkbox*/}
                            {/* {
                                      this.props.viewType === 'TabView' &&
                                      <td className="text-center">
                                            <input type='checkbox'
                                              className="cross_input"
                                              checked={row.GrFlache}
                                              disabled={((row.Alu || row.Push2paint) ? true : false) || Authorized}
                                              onChange={(e) => {
                                                this.handleAluLakChanges(e, index, "GrFlache");
                                              }}
                                            />
                                      </td>
                                    }   */}
                            {/* GrFlache */}
                            {/* <td className={this.props.viewType === 'TabView' ? "text-right column_grflache_value" : "text-right"}>
                                  {row.Part === 'TrunkCover' ?
                                      <p>
                                        {row.GrFlache ? 
                                          // ((this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),row.AWa, row.AWb,(row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),row.AWc) * 25.00) /100).toFixed(2)
                                          // (Math.round(((this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),row.AWa, row.AWb,(row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),row.AWc) * 25.00) /100) * 100) /100).toFixed(2)
                                          this.round((this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),row.AWa, row.AWb,(row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),row.AWc) * 25.00) /100).toFixed(2)

                                        : 
                                        ""
                                      }
                                      </p> 
                                    : 
                                      <p>
                                        {row.GrFlache ? 
                                            // (((this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc)) * 25.00) / 100.0).toFixed(2)
                                            // (M ath.round((this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc) * 25.00 / 100) * 100) / 100).toFixed(2)
                                            this.round(this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, row.AWc) * 25.00 / 100).toFixed(2)
                                        : 
                                          ""
                                        }
                                      </p>

                                    }
                                  </td> */}
                            {this.props.viewType != "TabView" && (
                              <td className="empty_row"></td>
                            )}

                            {/* Replacing */}

                            {this.props.viewType === "TabView" && (
                              <>
                                <td className="empty_row"></td>

                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-center ${
                                    this.props.viewType === "TabView"
                                      ? "blue-col"
                                      : ""
                                  }`}
                                >
                                  {row.Part === "TrunkCover" &&
                                  data[findWithAttr(data, "Part", "Trunk")] ? (
                                    <input
                                      type="checkbox"
                                      className="cross_input"
                                      checked={
                                        row.Replacing ||
                                        data[
                                          findWithAttr(data, "Part", "Trunk")
                                        ].Replacing
                                      }
                                      disabled={
                                        Authorized ||
                                        row.Preprints ||
                                        row.Plastic
                                      }
                                      onChange={(e) => {
                                        this.handleReplaceChanges(
                                          e,
                                          index,
                                          "Replacing"
                                        );
                                      }}
                                    />
                                  ) : (
                                    <input
                                      type="checkbox"
                                      className="cross_input"
                                      checked={row.Replacing}
                                      disabled={
                                        Authorized ||
                                        row.Preprints ||
                                        row.Plastic
                                      }
                                      onChange={(e) => {
                                        this.handleReplaceChanges(
                                          e,
                                          index,
                                          "Replacing"
                                        );
                                      }}
                                    />
                                  )}
                                </td>

                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-center ${
                                    this.props.viewType === "TabView"
                                      ? "blue-col"
                                      : ""
                                  }`}
                                >
                                  {row.Part === "TrunkCover" &&
                                  data[findWithAttr(data, "Part", "Trunk")] ? (
                                    <input
                                      type="checkbox"
                                      className="cross_input"
                                      checked={
                                        row.Preprints ||
                                        data[
                                          findWithAttr(data, "Part", "Trunk")
                                        ].Preprints
                                      }
                                      disabled={
                                        Authorized ||
                                        row.Replacing ||
                                        row.Plastic
                                      }
                                      onChange={(e) => {
                                        this.handleReplaceChanges(
                                          e,
                                          index,
                                          "Preprints"
                                        );
                                      }}
                                    />
                                  ) : (
                                    <input
                                      type="checkbox"
                                      className="cross_input"
                                      checked={row.Preprints}
                                      disabled={
                                        Authorized ||
                                        row.Replacing ||
                                        row.Plastic
                                      }
                                      onChange={(e) => {
                                        this.handleReplaceChanges(
                                          e,
                                          index,
                                          "Preprints"
                                        );
                                      }}
                                    />
                                  )}
                                </td>

                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-center ${
                                    this.props.viewType === "TabView"
                                      ? "blue-col"
                                      : ""
                                  }`}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "100%",
                                    }}
                                  >
                                    <input
                                      type="number"
                                      className="hidden-input"
                                      disabled={Authorized}
                                      name="Replacingvalue"
                                      step="0.01"
                                      value={
                                        row.Plastic
                                          ? ""
                                          : row.Replacing
                                          ? 0.0 || row.Replacingvalue
                                          : row.Preprints
                                          ? row.Replacingvalue
                                          : ""
                                      }
                                      onChange={(e) => {
                                        this.handleInputChange(e, row, index);
                                      }}
                                    />
                                    {!Authorized && (
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max(
                                              (parseFloat(row.Replacingvalue) ||
                                                0.0) - 0.01,
                                              0.0
                                            ).toFixed(2);
                                            this.handleInputChange(
                                              {
                                                target: {
                                                  name: "Replacingvalue",
                                                  value: updatedValue,
                                                },
                                              },
                                              row,
                                              index
                                            );
                                          }}
                                          className="decrement-button"
                                          disabled={Authorized}
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (
                                              (parseFloat(row.Replacingvalue) ||
                                                0.0) + 0.01
                                            ).toFixed(2);
                                            this.handleInputChange(
                                              {
                                                target: {
                                                  name: "Replacingvalue",
                                                  value: updatedValue,
                                                },
                                              },
                                              row,
                                              index
                                            );
                                          }}
                                          className="increment-button"
                                          disabled={Authorized}
                                        >
                                          +
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </>
                            )}

                            {this.props.viewType == "DAT" && (
                              <td
                                style={dynamic_Table_Colors}
                                className="text-right  price-tbody-td"
                              >
                                <p>
                                  {row.Plastic
                                    ? ""
                                    : row.Replacing
                                    ? 0.0 || row.Replacingvalue
                                    : row.Preprints
                                    ? row.Replacingvalue
                                    : ""}
                                </p>
                              </td>
                            )}

                            {(this.props.viewType === "TabView" ||
                              this.props.viewType === "DAT") && (
                              <td className="empty_row"></td>
                            )}

                            {/* Gesamt (total AW) */}
                            <td
                              style={dynamic_Table_Colors}
                              className={"text-center price-tbody-td"}
                            >
                              {/* <p style={{ color: (row.AW > 111 || this.getOriginalAW(row.A, row.B, row.AWa, row.AWb, row.C, 0, row.Part, true) > 111) && this.props.viewType === 'TabView' ? "red" : "black" }}> */}
                              <p
                                style={{
                                  color:
                                    (row.AW >= 188.0 ||
                                      this.getOriginalAW(
                                        row.A,
                                        row.B,
                                        row.AWa,
                                        row.AWb,
                                        row.C,
                                        0,
                                        row.Part,
                                        true
                                      ) >= 188.0) &&
                                    this.props.viewType === "TabView"
                                      ? "red"
                                      : "black",
                                }}
                              >
                                {
                                  // (row.Part === "Trunk" && data[findWithAttr(data, 'Part', 'TrunkCover')]) ?
                                  //   row.AW + data[findWithAttr(data, 'Part', 'TrunkCover')].AW
                                  // :
                                  row.Plastic
                                    ? "0.00"
                                    : row.Replacing
                                    ? 0.0 || row.Replacingvalue
                                    : row.Preprints
                                    ? row.Replacingvalue
                                    : row.AW
                                }
                              </p>
                            </td>
                            {this.props.viewType != "DAT" && (
                              <td className="empty_row"></td>
                            )}
                            {/* Disassembly and assembly */}
                            {this.props.viewType === "DAT"
                              ? " "
                              : this.props.viewType === "TabView" && (
                                  <td
                                    className="text-right price-tbody-td"
                                    style={dynamic_Table_Colors}
                                  >
                                    <input
                                      type="checkbox"
                                      className="cross_input"
                                      checked={row.disassemblyAssembly}
                                      disabled={Authorized}
                                      onChange={(e) => {
                                        this.handleAluLakChanges(
                                          e,
                                          index,
                                          "disassemblyAssembly"
                                        );
                                      }}
                                    />
                                  </td>
                                )}
                            {this.props.viewType != "DAT" && (
                              <td
                                className="text-right"
                                style={dynamic_Table_Colors}
                              >
                                {this.props.viewType === "TabView" ? (
                                  <input
                                    type="number"
                                    name="disassemblyAssemblyAW"
                                    id="disassemblyAndAssembly"
                                    value={
                                      row.disassemblyAssembly
                                        ? row.disassemblyAssemblyAW
                                          ? row.disassemblyAssemblyAW
                                          : (data[index].disassemblyAssemblyAW =
                                              disassemblyAssemblyValue[index])
                                        : ""
                                    }
                                    onChange={(e) =>
                                      this.handleAWchanges(index, e)
                                    }
                                    min={0}
                                    disabled={Authorized}
                                    // disabled
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "right",
                                      color: "black",
                                      fontWeight: 500,
                                    }}
                                  />
                                ) : (
                                  <p className="p-0 m-0 text-right">
                                    {/* {row.disassemblyAssembly ? (row.disassemblyAssemblyAW ? row.disassemblyAssemblyAW.toFixed(2) :  disassemblyAssemblyValue[index].toFixed(2)) : ""} */}
                                    {row.disassemblyAssembly
                                      ? row.disassemblyAssemblyAW
                                        ? parseFloat(
                                            row.disassemblyAssemblyAW
                                          ).toFixed(2)
                                        : 0
                                      : ""}
                                  </p>
                                )}
                              </td>
                            )}
                            {this.props.viewType === "TabView" && (
                              <td className="empty_row"></td>
                            )}
                            {this.props.viewType === "TabView" && (
                              <>
                                {/* ersetzen */}
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`text-center inner_line checkout-col-td checkout-bottom-border-td price-tbody-td ${
                                    this.props.viewType === "TabView"
                                      ? "green-col"
                                      : ""
                                  }`}
                                >
                                  {row.arrAE &&
                                    row.arrAE.dataAE.length &&
                                    row.arrAE.dataAE.map((checkbox_val, i) => {
                                      return (
                                        <span
                                          // className="input-checkbox-span"
                                          key={i}
                                          className={`input-checkbox-span ${
                                            row.arrAE.dataAE.length == 1
                                              ? "one-input-value"
                                              : "two-input-value"
                                          }`}
                                        >
                                          <input
                                            className="cross_input"
                                            type="checkbox"
                                            checked={
                                              Array.isArray(
                                                data[index]["AE"]
                                              ) &&
                                              data[index]["AE"].includes(
                                                checkbox_val
                                              )
                                                ? true
                                                : false
                                            }
                                            onChange={(event) =>
                                              this.changeAE(
                                                event,
                                                index,
                                                checkbox_val
                                              )
                                            }
                                            disabled={Authorized}
                                            // disabled
                                          />
                                        </span>
                                      );
                                    })}
                                </td>
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-left price-table-checkbox-td ${
                                    this.props.viewType === "TabView"
                                      ? "green-col"
                                      : ""
                                  }`}
                                >
                                  <div className="ae-content p-0">
                                    {Array.isArray(
                                      row.arrAE && row.arrAE.dataAE
                                    ) &&
                                      row.arrAE.dataAE.map(
                                        (checkbox_val, i) => {
                                          return (
                                            <Fragment key={i}>
                                              <p
                                                className={`last-para-text check-box-para-text ${
                                                  row.arrAE.dataAE.length == 1
                                                    ? "one-input-value"
                                                    : "two-input-value"
                                                }`}
                                              >
                                                {this.lang(checkbox_val)}
                                              </p>
                                            </Fragment>
                                          );
                                        }
                                      )}
                                  </div>
                                </td>
                                {/* Ersetzen */}
                                {/* <td className="text-center inner_line">
                                      <span>
                                        <input
                                            type="checkbox"
                                            className="cross_input"
                                            checked={row.Replace==='check_E'}   
                                            name='check_E'
                                            onChange={(e) => {
                                              this.change(row.Part, e, index);
                                            }}    
                                          />
                                      </span>
                                      <span>
                                        <input
                                          className="cross_input"
                                          type="checkbox"
                                          checked={row.Replace==='Check_I_LI'}    
                                          name="check_I_LI"
                                          onChange={(e) => {
                                            this.change(row.Part, e, index);
                                          }}    
                                        />
                                      </span>
                                    </td>
                                    <td className="text-center inner_line">
                                      <span>E</span>
                                      <span>I/LI</span>
                                    </td> */}
                              </>
                            )}
                          </tr>
                        )
                      );
                    })}
                  <tr className="tbody-last-tr">
                    <td
                      style={dynamic_Table_Colors}
                      className={`text-left both-bottom-border tbody-last-footer-td ${
                        this.props.viewType === "TabView"
                          ? "thead_top_border"
                          : ""
                      }`}
                    >
                      {this.lang("Total")}
                    </td>

                    {this.props.viewType === "TabView" && (
                      <>
                        <td className="empty_row"></td>

                        <td
                          style={dynamic_Table_Colors}
                          className={`text-center both-bottom-border tbody-last-footer-td ${
                            this.props.viewType === "TabView"
                              ? "dark-gray-col thead_top_border"
                              : ""
                          }`}
                        ></td>
                      </>
                    )}

                    <td className="empty_row"></td>

                    {/* Total row.A */}
                    <td
                      style={dynamic_Table_Colors}
                      className={`text-center bottom-left-border tbody-last-footer-td ${
                        this.props.viewType === "TabView"
                          ? "light-gray-col thead_top_border"
                          : ""
                      }`}
                    >
                      {this.props.viewType === "TabView" ? (
                        <input
                          type="number"
                          name="AWc"
                          style={{
                            width: "100%",
                            border: "none",
                            outline: "none",
                            textAlign: "center",
                            color: "black",
                            fontWeight: 500,
                          }}
                          min="0"
                          value={
                            data &&
                            data.reduce((acc, num) => {
                              if (
                                num.Part !== "LeftFrontTyre" &&
                                num.Part !== "LeftBackTyre" &&
                                num.Part !== "RightFrontTyre" &&
                                num.Part !== "RightBackTyre" &&
                                num.Part !== "FrontBumper" &&
                                num.Part !== "BackBumper" &&
                                num.Part !== "Underbody" &&
                                num.Part !== "Inside"
                              ) {
                                return (
                                  parseFloat(acc) +
                                  parseFloat(num.Plastic ? 0 : num.A)
                                );
                              } else {
                                return parseFloat(acc);
                              }
                            }, 0)
                          }
                          disabled
                        />
                      ) : (
                        <>
                          {" "}
                          {data &&
                            data.reduce((acc, num) => {
                              if (
                                num.Part !== "LeftFrontTyre" &&
                                num.Part !== "LeftBackTyre" &&
                                num.Part !== "RightFrontTyre" &&
                                num.Part !== "RightBackTyre" &&
                                num.Part !== "FrontBumper" &&
                                num.Part !== "BackBumper" &&
                                num.Part !== "Underbody" &&
                                num.Part !== "Inside"
                              ) {
                                return (
                                  parseFloat(acc) +
                                  parseFloat(num.Plastic ? 0 : num.A)
                                );
                              } else {
                                return parseFloat(acc);
                              }
                            }, 0)}
                        </>
                      )}
                    </td>
                    {/* Total row.B */}
                    <td
                      style={dynamic_Table_Colors}
                      className={`text-center tbody-last-footer-td ${
                        this.props.viewType === "TabView"
                          ? "light-gray-col thead_top_border"
                          : "bottom-right-border"
                      }`}
                    >
                      <>
                        {" "}
                        {
                          this.props.viewType === "TabView" ? (
                            <input
                              className="price-table-input"
                              type="number"
                              name="AWc"
                              style={{
                                width: "100%",
                                border: "none",
                                outline: "none",
                                textAlign: "center",
                                color: "black",
                                fontWeight: 500,
                              }}
                              min="0"
                              value={
                                data &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== "LeftFrontTyre" &&
                                    num.Part !== "LeftBackTyre" &&
                                    num.Part !== "RightFrontTyre" &&
                                    num.Part !== "RightBackTyre" &&
                                    num.Part !== "FrontBumper" &&
                                    num.Part !== "BackBumper" &&
                                    num.Part !== "Underbody" &&
                                    num.Part !== "Inside"
                                  ) {
                                    return (
                                      parseFloat(acc) +
                                      parseFloat(num.Plastic ? 0 : num.B)
                                    );
                                  } else {
                                    return parseFloat(acc);
                                  }
                                }, 0)
                              }
                              disabled
                            />
                          ) : (
                            data &&
                            data.reduce((acc, num) => {
                              if (
                                num.Part !== "LeftFrontTyre" &&
                                num.Part !== "LeftBackTyre" &&
                                num.Part !== "RightFrontTyre" &&
                                num.Part !== "RightBackTyre" &&
                                num.Part !== "FrontBumper" &&
                                num.Part !== "BackBumper" &&
                                num.Part !== "Underbody" &&
                                num.Part !== "Inside"
                              ) {
                                return (
                                  parseFloat(acc) +
                                  parseFloat(num.Plastic ? 0 : num.B) +
                                  parseFloat(
                                    num.Plastic ? 0 : num.C ? num.C : 0
                                  )
                                );
                              } else {
                                return parseFloat(acc);
                              }
                            }, 0)
                          )
                          // for total_B(total_C))
                          // (${data &&
                          //   data.reduce(
                          //     (acc, num) =>{
                          //       if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                          //         return parseFloat(acc) + parseFloat(num.C ? num.C : 0);
                          //       } else {
                          //         return parseFloat(acc);
                          //       }
                          //     },
                          //     0
                          //   )
                          // })
                        }{" "}
                      </>
                    </td>
                    {/* Total row.C */}
                    {this.props.viewType === "TabView" && (
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td ${
                          this.props.viewType === "TabView"
                            ? "light-gray-col bottom-right-border thead_top_border"
                            : ""
                        }`}
                      >
                        <>
                          <input
                            className="price-table-input"
                            type="number"
                            name="AWc"
                            style={{
                              width: "100%",
                              border: "none",
                              outline: "none",
                              textAlign: "center",
                              color: "black",
                              fontWeight: 500,
                            }}
                            min="0"
                            value={
                              data &&
                              data.reduce((acc, num) => {
                                if (
                                  num.Part !== "LeftFrontTyre" &&
                                  num.Part !== "LeftBackTyre" &&
                                  num.Part !== "RightFrontTyre" &&
                                  num.Part !== "RightBackTyre" &&
                                  num.Part !== "FrontBumper" &&
                                  num.Part !== "BackBumper" &&
                                  num.Part !== "Underbody" &&
                                  num.Part !== "Inside"
                                ) {
                                  return (
                                    parseFloat(acc) +
                                    parseFloat(
                                      num.Plastic ? 0 : num.C ? num.C : 0
                                    )
                                  );
                                } else {
                                  return parseFloat(acc);
                                }
                              }, 0)
                            }
                            disabled
                          />
                        </>
                      </td>
                    )}
                    {/* Total AWa 
                              <td className="text-center">
                                <p>
                                  {" "}
                                  {data && 
                                    data.reduce(
                                      (acc, num) =>{
                                        if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                                          return (parseFloat(acc) + num.AWa);
                                        } else { 
                                          return parseFloat(acc);
                                        }
                                      },
                                      0
                                    )
                                  }
                                </p>
                              </td>
                             // TOtal AWb 
                              <td className="text-center">
                                <p>
                                  {" "}
                                  {data && 
                                    data.reduce(
                                      (acc, num) =>{
                                        if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                                          return (parseFloat(acc) + num.AWb);
                                        } else { 
                                          return parseFloat(acc);
                                        }
                                      },
                                      0
                                    )
                                  }
                                </p>
                              </td>
                              */}
                    <td className="empty_row"></td>

                    {/* Total OriginalAW */}
                    <td
                      style={dynamic_Table_Colors}
                      className={`text-center tbody-last-footer-td both-bottom-border ${
                        this.props.viewType === "TabView"
                          ? "dark-gray-col thead_top_border"
                          : ""
                      }`}
                    >
                      <>
                        {data &&
                          data.reduce((acc, num) => {
                            if (
                              num.Part !== "Trunk" &&
                              num.Part !== "LeftFrontTyre" &&
                              num.Part !== "LeftBackTyre" &&
                              num.Part !== "RightFrontTyre" &&
                              num.Part !== "RightBackTyre" &&
                              num.Part !== "FrontBumper" &&
                              num.Part !== "BackBumper" &&
                              num.Part !== "Underbody" &&
                              num.Part !== "Inside"
                            ) {
                              let ALU =
                                num.Part === "TrunkCover"
                                  ? num.Plastic
                                    ? 0
                                    : this.getOriginalAW(
                                        (num.A ? num.A : 0) +
                                          (data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ].A
                                            ? data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].A
                                            : 0),
                                        (num.B ? num.B : 0) +
                                          (data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ].B
                                            ? data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].B
                                            : 0),
                                        num.AWa,
                                        num.AWb,
                                        num.C +
                                          (data[
                                            findWithAttr(data, "Part", "Trunk")
                                          ].C
                                            ? data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].C
                                            : 0)
                                      )
                                  : parseFloat(
                                      num.Plastic
                                        ? 0
                                        : this.getOriginalAW(
                                            num.A,
                                            num.B,
                                            num.AWa,
                                            num.AWb,
                                            num.C
                                          )
                                    );
                              // > 111 ? 111 : parseFloat(this.getOriginalAW(num.A, num.B, num.AWa, num.AWb, num.C));
                              return (parseFloat(acc) + ALU).toFixed(2);
                            } else {
                              return parseFloat(acc).toFixed(2);
                            }
                          }, 0)}
                      </>
                    </td>
                    <td className="empty_row text-right"></td>
                    {/* Total uberG */}
                    {this.props.viewType === "TabView" && (
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td bottom-left-border ${
                          this.props.viewType === "TabView"
                            ? "yellow-col thead_top_border"
                            : ""
                        }`}
                      >
                        {this.props.viewType === "TabView" ? (
                          <>
                            <input
                              type="number"
                              name="AWc"
                              style={{
                                width: "100%",
                                border: "none",
                                outline: "none",
                                textAlign: "center",
                                color: "black",
                                fontWeight: 500,
                              }}
                              min="0"
                              value={
                                data &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== "LeftFrontTyre" &&
                                    num.Part !== "LeftBackTyre" &&
                                    num.Part !== "RightFrontTyre" &&
                                    num.Part !== "RightBackTyre" &&
                                    num.Part !== "FrontBumper" &&
                                    num.Part !== "BackBumper" &&
                                    num.Part !== "Underbody" &&
                                    num.Part !== "Inside"
                                  ) {
                                    return (
                                      parseFloat(acc) + (num.AWc ? num.AWc : 0)
                                    );
                                  } else {
                                    return parseFloat(acc).toFixed(2);
                                  }
                                }, 0)
                              }
                              disabled
                            />
                          </>
                        ) : (
                          <>
                            {data &&
                              data.reduce((acc, num) => {
                                if (
                                  num.Part !== "LeftFrontTyre" &&
                                  num.Part !== "LeftBackTyre" &&
                                  num.Part !== "RightFrontTyre" &&
                                  num.Part !== "RightBackTyre" &&
                                  num.Part !== "FrontBumper" &&
                                  num.Part !== "BackBumper" &&
                                  num.Part !== "Underbody" &&
                                  num.Part !== "Inside"
                                ) {
                                  return (
                                    parseFloat(acc) + (num.AWc ? num.AWc : 0)
                                  );
                                } else {
                                  return parseFloat(acc).toFixed(2);
                                }
                              }, 0)}
                          </>
                        )}
                      </td>
                    )}
                    {/* {this.props.viewType !== 'DAT' && */}
                    <>
                      {this.props.viewType === "TabView" && (
                        <td
                          style={dynamic_Table_Colors}
                          className={`text-right tbody-last-footer-td ${
                            this.props.viewType === "TabView"
                              ? "orange-col thead_top_border"
                              : ""
                          }`}
                        ></td>
                      )}
                      {/* ALU% total */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-right tbody-last-footer-td ${
                          this.props.viewType === "TabView"
                            ? "orange-col thead_top_border"
                             : viewType == "DAT"
                             ? "both-bottom-border "
                            : ""
                        }`}
                      >
                        <>
                          {data &&
                            data.reduce((acc, num) => {
                              if (
                                num.Part !== "Trunk" &&
                                num.Part !== "LeftFrontTyre" &&
                                num.Part !== "LeftBackTyre" &&
                                num.Part !== "RightFrontTyre" &&
                                num.Part !== "RightBackTyre" &&
                                num.Part !== "FrontBumper" &&
                                num.Part !== "BackBumper" &&
                                num.Part !== "Underbody" &&
                                num.Part !== "Inside"
                              ) {
                                let ALU = num.Plastic
                                  ? ""
                                  : num.Alu
                                  ? num.Part === "TrunkCover"
                                    ? // parseFloat(((this.getOriginalAW((num.A ? num.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(num.B ? num.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),num.AWa, num.AWb,(num.C ? num.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),num.AWc) * ALUPercentage) /100).toFixed(2))
                                      // parseFloat((Math.round(((this.getOriginalAW((num.A ? num.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(num.B ? num.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),num.AWa, num.AWb,(num.C ? num.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),num.AWc) * ALUPercentage) /100) * 100) /100).toFixed(2))
                                      parseFloat(
                                        this.round(
                                          (this.getOriginalAW(
                                            (num.A ? num.A : 0) +
                                              (data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].A
                                                ? data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].A
                                                : 0),
                                            (num.B ? num.B : 0) +
                                              (data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].B
                                                ? data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].B
                                                : 0),
                                            num.AWa,
                                            num.AWb,
                                            (num.C ? num.C : 0) +
                                              (data[
                                                findWithAttr(
                                                  data,
                                                  "Part",
                                                  "Trunk"
                                                )
                                              ].C
                                                ? data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].C
                                                : 0),
                                            num.AWc
                                          ) *
                                            ALUPercentage) /
                                            100
                                        ).toFixed(2)
                                      )
                                    : // parseFloat((Math.round((this.getOriginalAW(num.A, num.B, num.AWa, num.AWb, num.C, num.AWc) * ALUPercentage / 100) * 100) / 100).toFixed(2))
                                      parseFloat(
                                        this.round(
                                          (this.getOriginalAW(
                                            num.A,
                                            num.B,
                                            num.AWa,
                                            num.AWb,
                                            num.C,
                                            num.AWc
                                          ) *
                                            ALUPercentage) /
                                            100
                                        ).toFixed(2)
                                      )
                                  : 0;
                                return parseFloat(acc) + ALU;
                              } else {
                                return parseFloat(acc).toFixed(2);
                              }
                            }, 0)}
                        </>
                      </td>
                      {this.props.viewType === "TabView" && (
                        <td
                          style={dynamic_Table_Colors}
                          className={`text-right tbody-last-footer-td ${
                            this.props.viewType === "TabView"
                              ? "dark-gray-col thead_top_border"
                              : ""
                          }`}
                        ></td>
                      )}
                      {
                        this.props.viewType === "DAT" && (
                    <td className="empty_row text-right"></td>
                        )
                      }

                      {(this.props.viewType === "TabView" || this.props.viewType === "DAT") && (
                        <>
                          {/* <td className="text-center"></td> */}

                          {/* Push2Paint% total */}
                          <td
                            style={dynamic_Table_Colors}
                            className={`text-center tbody-last-footer-td ${
                              this.props.viewType === "TabView"
                                ? "dark-gray-col thead_top_border"
                                : viewType === "DAT"
                                ? "both-bottom-border"
                                : ""
                            }`}
                          >
                            <>
                              {data &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== "Trunk" &&
                                    num.Part !== "LeftFrontTyre" &&
                                    num.Part !== "LeftBackTyre" &&
                                    num.Part !== "RightFrontTyre" &&
                                    num.Part !== "RightBackTyre" &&
                                    num.Part !== "FrontBumper" &&
                                    num.Part !== "BackBumper" &&
                                    num.Part !== "Underbody" &&
                                    num.Part !== "Inside"
                                  ) {
                                    let Push2Paint = num.Plastic
                                      ? ""
                                      : num.Push2paint
                                      ? num.Part === "TrunkCover"
                                        ? // parseFloat((Math.round(((this.getOriginalAW((num.A ? num.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(num.B ? num.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),num.AWa, num.AWb,(num.C ? num.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),num.AWc) * LAKPercentage) /100) * 100) /100).toFixed(2))
                                          parseFloat(
                                            this.round(
                                              (this.getOriginalAW(
                                                (num.A ? num.A : 0) +
                                                  (data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].A
                                                    ? data[
                                                        findWithAttr(
                                                          data,
                                                          "Part",
                                                          "Trunk"
                                                        )
                                                      ].A
                                                    : 0),
                                                (num.B ? num.B : 0) +
                                                  (data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].B
                                                    ? data[
                                                        findWithAttr(
                                                          data,
                                                          "Part",
                                                          "Trunk"
                                                        )
                                                      ].B
                                                    : 0),
                                                num.AWa,
                                                num.AWb,
                                                (num.C ? num.C : 0) +
                                                  (data[
                                                    findWithAttr(
                                                      data,
                                                      "Part",
                                                      "Trunk"
                                                    )
                                                  ].C
                                                    ? data[
                                                        findWithAttr(
                                                          data,
                                                          "Part",
                                                          "Trunk"
                                                        )
                                                      ].C
                                                    : 0),
                                                num.AWc
                                              ) *
                                                LAKPercentage) /
                                                100
                                            ).toFixed(2)
                                          )
                                        : // parseFloat((Math.round((this.getOriginalAW(num.A, num.B, num.AWa, num.AWb, num.C, num.AWc) * LAKPercentage / 100) * 100) / 100).toFixed(2))
                                          parseFloat(
                                            this.round(
                                              (this.getOriginalAW(
                                                num.A,
                                                num.B,
                                                num.AWa,
                                                num.AWb,
                                                num.C,
                                                num.AWc
                                              ) *
                                                LAKPercentage) /
                                                100
                                            ).toFixed(2)
                                          )
                                      : 0;
                                    return parseFloat(acc) + Push2Paint;
                                  } else {
                                    return parseFloat(acc).toFixed(2);
                                  }
                                }, 0)}
                            </>
                          </td>
                        </>
                      )}
                    </>
                    {this.props.viewType != "TabView" && (
                      <td className="empty_row"></td>
                    )}

                    {/* Total Replaceing */}
                    {this.props.viewType === "TabView" && (
                      <>
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          className={`text-center tbody-last-footer-td bottom-left-border ${
                            this.props.viewType === "TabView"
                              ? "blue-col thead_top_border"
                              : ""
                          }`}
                        ></td>
                        <td
                          style={dynamic_Table_Colors}
                          className={`text-center tbody-last-footer-td ${
                            this.props.viewType === "TabView"
                              ? "blue-col thead_top_border"
                              : ""
                          }`}
                        ></td>
                        <td
                          style={dynamic_Table_Colors}
                          className={`text-center tbody-last-footer-td bottom-right-border ${
                            this.props.viewType === "TabView"
                              ? "blue-col thead_top_border"
                              : ""
                          }`}
                        >
                          {isNaN(this.getReplaceingAddedAW())
                            ? 0
                            : this.getReplaceingAddedAW().toFixed(2)}
                        </td>
                      </>
                    )}

                    {this.props.viewType === "DAT" && (
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td both-bottom-border ${
                          this.props.viewType === "TabView"
                            ? "thead_top_border"
                            : ""
                        }`}
                      >
                        {isNaN(this.getReplaceingAddedAW())
                          ? 0
                          : this.getReplaceingAddedAW().toFixed(2)}
                      </td>
                    )}

                    {/* } */}
                    {/* {this.props.viewType === 'TabView' &&  <td className="text-center"></td>} */}
                    {/* GrFlache% total */}
                    {/* <td className={"text-right"}>
                                <p>
                                  {data && 
                                    data.reduce(
                                      (acc, num) =>{
                                        if (num.Part !== 'Trunk' && num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                                          let GrFlache = (num.GrFlache ? 
                                            (num.Part === 'TrunkCover' ? 
                                            // parseFloat((Math.round(((this.getOriginalAW((num.A ? num.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(num.B ? num.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),num.AWa, num.AWb,(num.C ? num.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),num.AWc) * 25.00) /100) * 100) /100).toFixed(2))
                                            parseFloat(this.round(((this.getOriginalAW((num.A ? num.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(num.B ? num.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),num.AWa, num.AWb,(num.C ? num.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),num.AWc) * 25.00) /100)).toFixed(2))
                                            //   parseFloat(((this.getOriginalAW((num.A ? num.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0),(num.B ? num.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0),num.AWa, num.AWb,(num.C ? num.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0),num.AWc) * 25.00) /100).toFixed(2))
                                            :
                                            // parseFloat((Math.round((this.getOriginalAW(num.A, num.B, num.AWa, num.AWb, num.C, num.AWc) * 25.00 / 100) * 100) / 100).toFixed(2))
                                             parseFloat(this.round((this.getOriginalAW(num.A, num.B, num.AWa, num.AWb, num.C, num.AWc) * 25.00 / 100)).toFixed(2))
                                            //   parseFloat((((this.getOriginalAW(num.A, num.B, num.AWa, num.AWb, num.C, num.AWc)) * 25.00) / 100.0).toFixed(2)))
                                            )
                                          : 
                                            0)
                                          return (parseFloat(acc) + GrFlache);
                                        } else { 
                                          return parseFloat(acc).toFixed(2);
                                        }
                                      },
                                      0
                                    )
                                  }
                                </p>
                              </td> */}
                    {(this.props.viewType === "TabView" ||
                      this.props.viewType === "DAT") && (
                      <td className="empty_row text-center"></td>
                    )}
                    {/* Total AW */}
                    <td
                      style={dynamic_Table_Colors}
                      className={`text-center tbody-last-footer-td both-bottom-border ${
                        this.props.viewType === "TabView"
                          ? "thead_top_border"
                          : ""
                      }`}
                    >
                      {data && isNaN(this.getTotalAw())
                        ? 0
                        : this.getTotalAw().toFixed(2)}
                    </td>

                    {this.props.viewType != "DAT" && (
                      <td className="empty_row text-center"></td>
                    )}

                    {this.props.viewType === "DAT"
                      ? " "
                      : this.props.viewType === "TabView" && (
                          <td
                            style={dynamic_Table_Colors}
                            className={`tbody-last-footer-td ${
                              this.props.viewType === "TabView"
                                ? "bottom-left-border"
                                : "both-bottom-border"
                            }`}
                          ></td>
                        )}
                    {/* getTotalDisassemblyAssemblyAW */}

                    {this.props.viewType === "DAT" ? (
                      " "
                    ) : (
                      <td
                        style={dynamic_Table_Colors}
                        className={`tbody-last-footer-td  text-center ${
                          this.props.viewType === "TabView"
                            ? "bottom-right-border"
                            : "both-bottom-border"
                        }`}
                      >
                        {this.getTotalDisassemblyAssemblyAW()}
                      </td>
                    )}
                    {this.props.viewType === "TabView" && (
                      <td className="empty_row text-center"></td>
                    )}

                    {this.props.viewType === "TabView" && (
                      <>
                        <td
                          style={dynamic_Table_Colors}
                          className={`tbody-last-footer-td  text-center ${
                            this.props.viewType === "TabView"
                              ? "green-col bottom-left-border"
                              : ""
                          }`}
                        ></td>
                        <td
                          style={dynamic_Table_Colors}
                          className={`tbody-last-footer-td  text-center ${
                            this.props.viewType === "TabView"
                              ? "green-col bottom-right-border"
                              : ""
                          }`}
                        ></td>
                      </>
                    )}
                  </tr>
                  {/* <tr>
                    <td className="empty_row p-1"></td>
                  </tr> */}
                </tbody>

                {this.props.viewType === "DAT" ? (
                  <tfoot className="new-report-tfoot dat_footer">
                    <tr>
                      <td className="dat_height"></td>
                    </tr>
                    <tr className="footer-header-wrapper">
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 18 : 11}
                        className="both-top-border footer-header-td"
                      >
                        {this.lang("Details")}
                      </td>
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 3 : 2}
                        className="both-top-border footer-header-td"
                      >
                        {this.lang("AW")}
                      </td>
                    </tr>
                    <tr className="footer-body">
                      <td className="empty_row"></td>
                      {/* Preparation AW */}
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 18 : 11}
                        className="text-left footer-body-td"
                      >
                        <b className="p-0 m-0">{this.lang("Preparation AW")}</b>
                      </td>
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 3 : 2}
                        className="text-right footer-body-td"
                      >
                        <b>{parseFloat(this.state.preparation).toFixed(2)}</b>
                      </td>
                    </tr>
                    <tr className="footer-body">
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 18 : 11}
                        className="text-left footer-body-td"
                      >
                        <b>{this.lang("totalDentsPress")}</b>
                      </td>
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 3 : 2}
                        className="text-right footer-body-td"
                      >
                        <b>
                          {data && isNaN(this.getAddedTotalAW())
                            ? 0
                            : this.getAddedTotalAW()}
                        </b>
                      </td>
                    </tr>
                    <tr className="bottom-tfoot-text">
                      <td colSpan="15" className="text-right border-0 pr-0">
                        <p className="report_text_bottom">
                          {this.lang(
                            "Deviations from the calculation are accepted only after consultation with the vehicle expert."
                          )}
                        </p>
                      </td>
                    </tr>
                  </tfoot>
                ) : (
                  <tfoot className="new-report-tfoot">
                    <tr className="footer-title-wrapper">
                      <td colSpan={27} className="title-td">
                        <div className="theme-title-wrapper bottom-footer-title">
                          <h3 className="theme-title-tag">
                            {this.lang("Repair_cost")}
                            <span>{this.lang("costs")}</span>
                          </h3>
                        </div>
                      </td>
                    </tr>
                    <tr className="footer-header-wrapper">
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 18 : 11}
                        className="top-left-border footer-header-td"
                      >
                        {this.lang("Details")}
                      </td>
                      <td
                        colSpan={this.props.viewType === "TabView" ? 2 : 1}
                        style={dynamic_Table_Colors}
                        width={"6%"}
                        className="footer-header-td"
                      >
                        {this.lang("AW")}
                      </td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 4 : 2}
                        className="top-right-border footer-header-td"
                      >
                        {this.lang("Hourly rate")}
                      </td>
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 4 : 2}
                        className="both-top-border footer-header-td"
                      >
                        {this.lang("Repair_costs")}
                      </td>
                    </tr>
                    <tr className="footer-body">
                      {/* Preparation AW */}
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 18 : 11}
                        className="new-border-right-white footer-body-td"
                      >
                        <b className="p-0 m-0">{this.lang("Preparation AW")}</b>
                      </td>
                      <td
                        colSpan={this.props.viewType === "TabView" ? 2 : 1}
                        className="text-right new-border-right-white footer-body-td"
                      >
                        <b>
                          {this.props.viewType === "TabView" ? (
                            <input
                              type="number"
                              style={{
                                width: "100%",
                                border: "none",
                                outline: "none",
                                textAlign: "right",
                              }}
                              value={this.state.preparation}
                              name="preparation"
                              onChange={this.handleChange}
                              disabled={Authorized}
                              min="0"
                              // width='100%'
                            />
                          ) : (
                            <p className="text-right p-0 m-0">
                              {parseFloat(this.state.preparation).toFixed(2)}
                            </p>
                          )}
                        </b>
                      </td>
                      <td
                        colSpan={this.props.viewType === "TabView" ? 4 : 2}
                        className="footer-body-td"
                      >
                        <table className="footer-inner-table">
                          <td className="text-left">
                            {/* <b>{this.lang("Fr")}</b> */}
                          </td>
                          <td className="text-right">
                            {/* <b>{data && isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW()}</b> */}
                          </td>
                        </table>
                      </td>
                      <td className="empty_row"></td>
                      <td
                        className="footer-body-td"
                        colSpan={this.props.viewType === "TabView" ? 4 : 2}
                      >
                        <table className="footer-inner-table">
                          <td className="text-center">
                            {/* <b>{this.lang("Fr")}</b> */}
                          </td>
                          <td className="text-right">
                            {/* <b>{data && isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW()}</b> */}
                          </td>
                        </table>
                      </td>
                    </tr>
                    <tr className="footer-body">
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 18 : 11}
                        className="new-border-right-white footer-body-td"
                      >
                        <b>{this.lang("totalPressAW")}</b>
                      </td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 2 : 1}
                        className="text-right new-border-right-white footer-body-td"
                      >
                        <b>
                          {data && isNaN(this.getAddedTotalAW())
                            ? 0
                            : this.getAddedTotalAW()}
                        </b>
                      </td>
                      {/* PricePerHour */}
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 4 : 2}
                        className="footer-body-td"
                      >
                        <table className="footer-inner-table">
                          <td className="text-left">
                            <b>{this.lang("Fr")}</b>
                          </td>
                          <td className="text-right">
                            <b>
                              {this.props.viewType === "TabView" ? (
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                  className="min-width-100"
                                >
                                  <input
                                    type="number"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                    }}
                                    onChange={this.handleChange}
                                    name="PricePerHour"
                                    value={this.state.PricePerHour}
                                    disabled={Authorized}
                                    // width='100%'
                                  />
                                  {!Authorized && (
                                    <div className="button-table-arrow-position">
                                      <button
                                        onClick={(e) =>
                                          this.handleChange(
                                            {
                                              target: {
                                                name: "PricePerHour",
                                                value: this.state.PricePerHour,
                                              },
                                            },
                                            "decrement"
                                          )
                                        }
                                        disabled={Authorized}
                                        className="decrement-button"
                                      >
                                        -
                                      </button>
                                      <button
                                        onClick={(e) =>
                                          this.handleChange(
                                            {
                                              target: {
                                                name: "PricePerHour",
                                                value: this.state.PricePerHour,
                                              },
                                            },
                                            "increment"
                                          )
                                        }
                                        disabled={Authorized}
                                        className="increment-button"
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <p
                                  className="p-0 m-0"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  {parseFloat(this.state.PricePerHour).toFixed(
                                    2
                                  )}
                                </p>
                              )}
                            </b>
                          </td>
                        </table>
                      </td>
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        className="footer-body-td"
                        colSpan={this.props.viewType === "TabView" ? 4 : 2}
                      >
                        <table className="footer-inner-table">
                          <td className="text-left">
                            <b>{this.lang("Fr")}</b>
                          </td>
                          <td
                            style={{ border: "none", padding: 0 }}
                            className={"text-right"}
                          >
                            <p className="p-0 m-0">
                              <b>{this.getAmount()}</b>
                            </p>
                          </td>
                        </table>
                      </td>
                    </tr>
                    <tr className="footer-body">
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 18 : 9}
                        className="new-border-right-white footer-body-td"
                      >
                        <b>{this.lang("disassemblyAndAssemblyAW")}</b>
                      </td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 2 : 1}
                        className="text-right new-border-right-white footer-body-td"
                      >
                        <p className="m-0 p-0">
                          {data &&
                          isNaN(this.getAddedTotalDisassemblyAssemblyAW())
                            ? 0
                            : this.getAddedTotalDisassemblyAssemblyAW()}
                        </p>
                      </td>
                      {/* Price/hrDe-&montage */}
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 4 : 2}
                        className="footer-body-td"
                      >
                        <table className="footer-inner-table">
                          <td className="text-left">
                            <b>{this.lang("Fr")}</b>
                          </td>
                          <td className="text-right">
                            <b>
                              {this.props.viewType === "TabView" ? (
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                  className="min-width-100"
                                >
                                  <input
                                    type="number"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                    }}
                                    onChange={this.handleChange}
                                    name="DisassemblyAssemblyPricePerHour"
                                    value={
                                      this.state.DisassemblyAssemblyPricePerHour
                                    }
                                    disabled={Authorized}
                                    // width='100%'
                                  />
                                  {!Authorized && (
                                    <div className="button-table-arrow-position">
                                      <button
                                        onClick={(e) =>
                                          this.handleChange(
                                            {
                                              target: {
                                                name: "DisassemblyAssemblyPricePerHour",
                                                value:
                                                  this.state
                                                    .DisassemblyAssemblyPricePerHour,
                                              },
                                            },
                                            "decrement"
                                          )
                                        }
                                        disabled={Authorized}
                                        className="decrement-button"
                                      >
                                        -
                                      </button>
                                      <button
                                        onClick={(e) =>
                                          this.handleChange(
                                            {
                                              target: {
                                                name: "DisassemblyAssemblyPricePerHour",
                                                value:
                                                  this.state
                                                    .DisassemblyAssemblyPricePerHour,
                                              },
                                            },
                                            "increment"
                                          )
                                        }
                                        disabled={Authorized}
                                        className="increment-button"
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <p className="p-0 m-0">
                                  {parseFloat(
                                    this.state.DisassemblyAssemblyPricePerHour
                                  ).toFixed(2)}
                                </p>
                              )}
                            </b>
                          </td>
                        </table>
                      </td>
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 4 : 2}
                        className="footer-body-td"
                      >
                        <table className="footer-inner-table">
                          <td className="text-left">
                            <b>{this.lang("Fr")}</b>
                          </td>
                          <td
                            style={{ fontWeight: "", border: "none" }}
                            className={"text-right"}
                          >
                            <p className="p-0 m-0">
                              <b>{this.getDisassemblyAssemblyAmount()}</b>
                            </p>
                          </td>
                        </table>
                      </td>
                    </tr>
                    {/* kleinmaterial */}
                    <tr className="footer-body">
                      <td
                        colSpan={this.props.viewType === "TabView" ? 24 : 12}
                        className=" m-0 footer-body-td"
                        style={dynamic_Table_Colors}
                      >
                        <b>{this.lang("Small materials 5% max.Fr 100")}</b>
                      </td>
                      <td className="empty_row"></td>
                      <td
                        colSpan={this.props.viewType === "TabView" ? 4 : 3}
                        className={"text-right footer-body-td"}
                        style={dynamic_Table_Colors}
                      >
                        <table className="w-100 footer-inner-table">
                          <tr>
                            <td
                              className="p-0 text-left"
                              style={{
                                fontWeight: "normal",
                                border: "none",
                                fontSize: "14px",
                              }}
                            >
                              <b>{this.lang("Fr")}</b>
                            </td>
                            <td
                              style={{ border: "none", padding: 0 }}
                              className={"text-right"}
                            >
                              <b className="p-0 m-0">
                                {this.getKleinMaterial()}
                              </b>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    {/* SparePartsDetails*/}
                    <tr className="footer-body footer-body-last-tr">
                      <td
                        colSpan={this.props.viewType === "TabView" ? 24 : 12}
                        className="footer-body-td"
                        style={dynamic_Table_Colors}
                      >
                        <table className="w-100 footer-value-table">
                          <tr className="w-100">
                            <td
                              className="vertical-td-row last-td-footer"
                              width="20%"
                              style={{
                                border: "none",
                                textAlign: "left",
                                margin: 0,
                                padding: "0",
                              }}
                            >
                              <b className="m-0 p-0">
                                {this.lang("Spare Parts cost")}:
                              </b>
                            </td>
                            <td
                              className="all-checkbox-value-input"
                              style={{
                                border: "none",
                                textAlign: "left",
                                padding: "0",
                                fontWeight: "normal",
                              }}
                            >
                              {this.props.viewType === "TabView" ? (
                                <>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="UserEnteredSparePartsDetails"
                                    value={
                                      this.state.UserEnteredSparePartsDetails
                                    }
                                    onChange={this.handleChange}
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "left",
                                      color: "#23282c",
                                      boxShadow: "none",
                                    }}
                                    disabled={Authorized}
                                  />
                                  <span
                                    className="p-0 m-0"
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      color: "#424242",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    {this.state.partsFromAE.replaceAll(
                                      ",",
                                      ", "
                                    )}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span className="p-0 m-0">
                                    {this.state.UserEnteredSparePartsDetails}
                                  </span>
                                  <span
                                    className="p-0 m-0"
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      color: "#424242",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    {this.state.partsFromAE.replaceAll(
                                      ",",
                                      ", "
                                    )}
                                  </span>
                                </>
                              )}
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td className="empty_row"></td>
                      <td
                        style={dynamic_Table_Colors}
                        colSpan={4}
                        className="double_row_mix footer-body-td"
                      >
                        <table className="w-100 footer-inner-table">
                          <tr>
                            <td className="text-left">
                              <p>{this.lang("Fr")}</p>
                            </td>
                            <td
                              style={{ fontWeight: "", border: "none" }}
                              className="text-right"
                            >
                              {this.props.viewType === "TabView" ? (
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                  className="min-width-100"
                                >
                                  <input
                                    type="number"
                                    min="0"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                    }}
                                    onChange={this.handleChange}
                                    name="SpareParts"
                                    value={this.state.SpareParts}
                                    disabled={Authorized || platic_count == 13}
                                    // width='100%'
                                  />
                                  {!Authorized && (
                                    <div className="button-table-arrow-position">
                                      <button
                                        onClick={(e) =>
                                          this.handleChange(
                                            {
                                              target: {
                                                name: "SpareParts",
                                                value: this.state.SpareParts,
                                              },
                                            },
                                            "decrement"
                                          )
                                        }
                                        disabled={
                                          Authorized || platic_count == 13
                                        }
                                        className="decrement-button"
                                      >
                                        -
                                      </button>
                                      <button
                                        onClick={(e) =>
                                          this.handleChange(
                                            {
                                              target: {
                                                name: "SpareParts",
                                                value: this.state.SpareParts,
                                              },
                                            },
                                            "increment"
                                          )
                                        }
                                        disabled={
                                          Authorized || platic_count == 13
                                        }
                                        className="increment-button"
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <p className="text-right p-0 m-0">
                                  {this.state.SpareParts}
                                </p>
                              )}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr className="bottom-tfoot">
                      <td
                        colSpan={this.props.viewType === "TabView" ? 24 : 12}
                        style={dynamic_Table_Colors}
                        className="text-right p-0 m-0 both-bottom-border footer-foot-td"
                      >
                        {this.lang("Repair costs excl. VAT")}
                      </td>
                      <td className="empty_row"></td>

                      <td
                        style={dynamic_Table_Colors}
                        colSpan={4}
                        className={`both-bottom-border footer-foot-td ${
                          this.props.viewType === "TabView"
                            ? "text-center p-0 m-0"
                            : "text-right p-0 m-0"
                        }`}
                      >
                        <table className="w-100 ">
                          <tr>
                            <td
                              className="p-0 text-left"
                              style={{
                                fontWeight: "normal",
                                border: "none",
                                fontSize: "14px",
                                ...(partnerId === "TDCAG" && {
                                  backgroundColor:
                                    this.state.table_footer_color,
                                }),
                              }}
                            >
                              {this.lang("Fr")}
                            </td>
                            <td
                              style={{
                                border: "none",
                                padding: 0,
                                ...(partnerId === "TDCAG" && {
                                  backgroundColor:
                                    this.state.table_footer_color,
                                }),
                              }}
                              className={"text-right"}
                            >
                              {data &&
                                this.getRepairCost(
                                  data,
                                  this.state.preparation,
                                  this.state.dismantling
                                )}
                              {/* <p className="m-0 p-0" style={{ backgroundColor: "#0070C0 !important", color: "white" }}>
                                    </p> */}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    {this.props.viewType !== "DAT" && (
                      <tr className="bottom-tfoot-text">
                        <td className="empty_row"></td>
                        <td
                          colSpan={this.props.viewType === "TabView" ? 27 : 14}
                          className="text-right border-0 pr-0"
                        >
                          {/* <p>Abweichungen zur Kalkulation werden nur nach vorheriger Rücksprache mit dem Fahrzeugexperten akzeptiert.</p> */}
                          <p className="report_text_bottom">
                            {this.lang(
                              "Deviations from the calculation are accepted only after consultation with the vehicle expert."
                            )}
                          </p>
                        </td>
                      </tr>
                    )}
                  </tfoot>
                )}
              </table>
              <div>
              {
                  modal && (
                    <Lightbox
                      reactModalStyle={{
                        overlay: { zIndex: 100000000 },
                        content: {},
                      }}
                      mainSrc={
                        this.state.filteredImages.length > 0
                          ? `${this.state.filteredImages[this.state.currentImageIndex]}?t=${new Date().getTime()}` // Append timestamp
                          : require("../../assets/img/brand/dashboard-error-logo.png")
                      }
                      imageCaption={this.state.filteredImages.length > 0 && this.lang(
                        this.state.filteredImages[this.state.currentImageIndex]
                          .split('/')
                          .pop()
                          .replace(/^Report_/, '')
                          .replace(/_\d+\.jpg$/, '')
                      )}
                      nextSrc={
                        `${this.state.filteredImages[
                          (this.state.currentImageIndex + 1) % this.state.filteredImages.length
                        ]}?t=${new Date().getTime()}`
                      }
                      prevSrc={
                        `${this.state.filteredImages[
                          (this.state.currentImageIndex +
                            this.state.filteredImages.length -
                            1) % this.state.filteredImages.length
                        ]}?t=${new Date().getTime()}`
                      }
                      onCloseRequest={() => this.setState({ modal: false })}
                      onMovePrevRequest={() =>
                        this.setState({
                          currentImageIndex:
                            (this.state.currentImageIndex +
                              this.state.filteredImages.length -
                              1) %
                            this.state.filteredImages.length,
                        })
                      }
                      onMoveNextRequest={() =>
                        this.setState({
                          currentImageIndex:
                            (this.state.currentImageIndex + 1) %
                            this.state.filteredImages.length,
                        })
                      }
                      onImageLoadError={(...events) => console.log(events)}
                      imageLoadErrorMessage={
                        <img
                          style={{ height: "100%", width: "100%" }}
                          src={require("../../assets/img/brand/dashboard-error-logo.png")}
                        />
                      }
                    />
                  )
                  // <Lightbox
                  //   reactModalStyle={{
                  //     overlay: { zIndex: 100000000 },
                  //     content: {},
                  //   }}
                  //   mainSrc={
                  //     this.state.Platic_part && arr_part.includes(imgPartName) ?
                  //     configuration.imagePath +
                  //     "/scanImages/" +
                  //     partnerId +
                  //     "/" +
                  //     vin +
                  //     "/" +
                  //     "Report_" + imgPartName +'_4.jpg'
                  //     :
                  //     configuration.imagePath +
                  //     "/scanImages/" +
                  //     partnerId +
                  //     "/" +
                  //     vin +
                  //     "/" +
                  //     "Report_" + imgPartName +'_1.jpg'

                  //   }
                  //   onCloseRequest={() =>
                  //     this.setState({
                  //       modal: false,
                  //     })
                  //   }
                  //   onImageLoadError={(...events) => console.log(events)}
                  //   imageLoadErrorMessage={<img style={{height:'100%', width:"100%"}} src={require("../../assets/img/brand/dashboard-error-logo.png")} />}
                  // />
                }
              </div>
              <Modal
                centered
                size="lg"
                isOpen={this.state.modal_break}
                className="authorise_modalpopup"
                backdrop="static"
                toggle={() => this.setState({ modal_break: false })}
              >
                <ModalBody className="text-center">
                  <p className="mb-3 text-message-extra-image">
                    <b>
                      {this.lang("save in progress")}
                      <span className="dot-flashing"></span>
                    </b>
                  </p>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
    updateJsonData: (show) => dispatch(updateJsonData(show)),
    reportAuthorized: (show) => dispatch(reportAuthorized(show)),
  };
};
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    jsonData : props.jsonData,
    toggleReportDamageImage : props.toggleReportDamageImage
  };
};

export default connect(mapStateToProps,mapDispatchtoProps)(NewSwissPriceTable_zh);
